// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T20:23:47.610Z
// Property: Preserve at Mill Creek (ID: 6767906449167309)
// Collections: 33 amenities, 4 floorplans (live), 21 photos, 82 POIs, 5 reviews, 7 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "6767906449167309",
  "property_external_id": "5652607",
  "property_zillow_url": "https://www.zillow.com/apartments/buford-ga/preserve-at-mill-creek/5XhtwN/",
  "property_apartments_url": "https://www.apartments.com/preserve-at-mill-creek-buford-ga/mgywrdh/",
  "property_google_business_url": "https://www.google.com/maps/place/Preserve+at+Mill+Creek/data=!4m2!3m1!1s0x0:0xcdf66b718dfc848c?sa=X&ved=2ahUKEwjOnpWF8M6TAxWWlu4BHfGzMoYQ_BJ6BAgVEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "52980754854",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": "pcode : 5652607",
  "property_status": null,
  "property_slug": "preserve-at-mill-creek",
  "property_name": "Preserve at Mill Creek",
  "property_website_url": "https://www.preserveatmillcreekapts.com/",
  "property_domain": "https://www.preserveatmillcreek.com/",
  "property_address": "1400 Mall of Georgia Blvd",
  "property_full_address": "1400 Mall of Georgia Blvd, Buford, GA 30519",
  "property_address_1": "1400 Mall of Georgia Blvd",
  "property_address_2": null,
  "property_address_city": "Buford",
  "property_address_state": "GA",
  "property_address_zip_full": "30519-6593",
  "property_address_zip": "30519",
  "property_address_country": "US",
  "property_address_county": "Gwinnett County",
  "property_neighborhood_address": "Duluth",
  "property_address_latitude": "34.0591003",
  "property_address_longitude": "-83.99889379999999",
  "property_email": "millcreek@alapts.com",
  "property_phone": "(678) 714-9333",
  "property_call_tracking_phone": "678-269-7080",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Modern comfort beside Mall of Georgia energy.</strong> Explore roomy one-, two-, and three-bedroom <a href=\"/floor-plans\">apartment homes</a> with open-concept kitchens, quartz countertops, walk-in closets, and private outdoor space—then <a href=\"/schedule-a-tour\">schedule a tour</a> to see Preserve at Mill Creek in person.</p>",
  "property_long_description": "<p><strong>Modern comfort beside Mall of Georgia energy.</strong> At Preserve at Mill Creek, you get roomy one-, two-, and three-bedroom apartments with open-concept kitchens, quartz countertops, walk-in closets, 9-foot ceilings, ceiling fans, and private patios or balconies—plus select homes with stainless steel appliances, fireplaces, tray ceilings, and nature-trail views.</p><p>Outside your door, <a href=\"/amenities\">community amenities</a> make everyday routines feel easier: a sparkling pool with gazebos and fire pits, fitness center, clubhouse with Wi-Fi, grilling areas, dog park, EV charging, garages, package lockers, and a car care center. Controlled access and 24/7 online resident services add welcome convenience.</p><p>The location brings Buford’s best within easy reach. Shop, dine, and catch events at Mall of Georgia, head to The Exchange at Gwinnett for Topgolf, Andretti, restaurants, and Sprouts, or connect with the Ivy Creek Greenway near the Mall of Georgia Boulevard trailhead. Explore <a href=\"/floor-plans\">spacious floor plans</a> and settle into a polished home base in the Duluth–Buford area.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/01a04902-c43f-72c2-814f-8570a7c244c9.webp",
  "property_featured_image_media": {
    "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a view into the living room.",
    "public_id": "01a04902-c43f-72c2-814f-8570a7c244c9",
    "storage_key": "property/6767906449167309/01a04902-c43f-72c2-814f-8570a7c244c9.webp",
    "width": 1535,
    "height": 1024
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "400",
  "property_year_built": "2001",
  "property_year_renovated": null,
  "property_walk_score": "51",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "93.25",
  "property_admin_fee": "200",
  "property_application_fee": "100",
  "property_fees_deposit_info": "Application Approval Fee - Starting at $399",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $350 per pet, with a monthly pet rent of $25 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $350 per pet, with a monthly pet rent of $25 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://9306806.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://preserveatmillcreek.loftliving.com/login",
  "property_apply_now_url": "https://9306806.onlineleasing.realpage.com",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019e2205-64f8-757d-9c62-948cdca184f2.webp",
  "property_primary_logo_media": {
    "alt_text": "Preserve at Mill Creek Apartment Homes logo",
    "public_id": "019e2205-64f8-757d-9c62-948cdca184f2",
    "storage_key": "property/6767906449167309/019e2205-64f8-757d-9c62-948cdca184f2.webp",
    "width": 3072,
    "height": 1152
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019e2205-ef26-7109-bcb9-ea966ec334a4.webp",
  "property_icon_media": {
    "alt_text": "Geometric logo with a floral-like pattern in a hexagonal shape, on a dark blue background.",
    "public_id": "019e2205-ef26-7109-bcb9-ea966ec334a4",
    "storage_key": "property/6767906449167309/019e2205-ef26-7109-bcb9-ea966ec334a4.webp",
    "width": 2454,
    "height": 2454
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019e2205-ef26-7109-bcb9-ea966ec334a4.webp",
  "property_fav_icon_media": {
    "alt_text": "Geometric logo with a floral-like pattern in a hexagonal shape, on a dark blue background.",
    "public_id": "019e2205-ef26-7109-bcb9-ea966ec334a4",
    "storage_key": "property/6767906449167309/019e2205-ef26-7109-bcb9-ea966ec334a4.webp",
    "width": 2454,
    "height": 2454
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019faeb1-038d-73e8-b2b2-f27e5ede72fe.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Blank white image",
    "public_id": "019faeb1-038d-73e8-b2b2-f27e5ede72fe",
    "storage_key": "property/6767906449167309/019faeb1-038d-73e8-b2b2-f27e5ede72fe.webp",
    "width": 1280,
    "height": 480
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019faeb0-fb3b-70fc-b3b0-fe11d838b7b0.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Image not available",
    "public_id": "019faeb0-fb3b-70fc-b3b0-fe11d838b7b0",
    "storage_key": "property/6767906449167309/019faeb0-fb3b-70fc-b3b0-fe11d838b7b0.webp",
    "width": 1280,
    "height": 480
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#014f71",
  "property_secondary_color": "#beb6aa",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#ffffff",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "697 - 1406",
  "property_sqft_min": "697",
  "property_sqft_max": "1406",
  "property_price_range": "2235",
  "property_price_min": "1400",
  "property_price_max": "2235",
  "property_available_units": 27,
  "property_facebook_url": "https://www.facebook.com/PreserveatMillCreek",
  "property_instagram_url": "https://www.instagram.com/preserveatmillcreek/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJPbIxSDaU9YgRjIT8jXFr9s0",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/century-mill-creek-apartments-buford",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Preserve at Mill Creek",
  "property_home_romance_title": "Embrace Your New Life in a Beautiful Apartment Community",
  "property_home_amenities_blurb": "<p><strong>Convenience, comfort, and space to unwind.</strong> Preserve at Mill Creek brings daily ease into focus with controlled access, Amazon package lockers, EV charging, garage options, a car care center, and Spruce concierge cleaning. Recharge at the fitness center, modern clubhouse, poolside gazebos with fire pits, grilling areas, dog park, and scenic trails—then come home to quartz countertops, 9-foot ceilings, walk-in closets, garden tubs, and a private patio or balcony.</p>",
  "property_home_floorplans_blurb": "<p><strong>Find a layout that fits your rhythm.</strong> Preserve at Mill Creek offers one-, two-, and three-bedroom apartments with open-concept kitchens, quartz countertops, 9-foot ceilings, walk-in closets, and private patios or balconies. Select homes add fireplaces, tray ceilings with crown molding, stainless steel appliances, or nature-trail views—giving you more reasons to compare your favorites and see what’s available now.</p>",
  "property_home_gallery_blurb": "<p><strong>See Preserve at Mill Creek in focus.</strong> Preview airy interiors with wood-style flooring, quartz-topped kitchens, brushed-nickel lighting, and open layouts, then step outside to poolside views, shaded gazebos with fire pits, a clubhouse, courtyard, dog park, and green trails. Browse the full gallery for the details that bring these Buford apartments to life.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Buford convenience, with green space in the mix.</strong> From Preserve at Mill Creek, days can move easily from Mall of Georgia shopping and dining to downtown Buford favorites or a walk along Ivy Creek Greenway. Lake Lanier, Parsons Alley, Buford Drive, I-85, and I-985 are all within easy reach, giving the neighborhood a practical pace with plenty to explore.</p>",
  "property_home_reviews_blurb": "<p><strong>A quiet setting with a cared-for feel.</strong> Reviews for Preserve at Mill Creek often point to the same highlights: beautifully kept grounds, peaceful surroundings, and easy access to the Ivy Creek walking trails. Residents also praise the friendly office team, responsive maintenance, and quick communication that help the community feel well looked after. Read the reviews to see why one resident called it a “hidden tranquil gem.”</p>",
  "property_neighborhood_blurb": "<p><strong>Gwinnett energy, with green space close by.</strong> At Preserve at Mill Creek, you’re set along the Duluth–Buford corridor where a quick errand can turn into dinner, a movie, or an afternoon outdoors. Head toward Mall of Georgia for major retail and restaurants, explore Main Street shops and local dining in downtown Buford, or spend time on the Ivy Creek Greenway near the Gwinnett Environmental &amp; Heritage Center. When you want a bigger change of scenery, Lake Lanier and downtown Duluth’s Parsons Alley dining scene are easy additions to the map.</p><p>With access to Buford Drive, I-85, and I-985, your neighborhood keeps daily routes practical while giving you plenty to discover. Browse the map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Preserve at Mill Creek places it all within reach.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that make the day feel smoother.</strong> At Preserve at Mill Creek, everyday convenience is built into the community experience—from controlled access, Amazon package lockers, online resident services, and EV charging to garage options, a car care center, and concierge cleaning available through Spruce.</p><p>When you want to reset, move between the fitness center, modern clubhouse with complimentary Wi-Fi, poolside gazebos with fire pits, outdoor grilling spaces, dog park, and scenic walking and biking trails. Inside your apartment, polished details like open-concept kitchens, quartz countertops, 9-foot ceilings, walk-in closets, garden tubs, private patios or balconies, and select renovated finishes create a home that feels both practical and elevated. Browse the <a href=\"/gallery\">amenity photos</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see it all in person.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make your move?</strong> Choose a roomy one-, two-, or three-bedroom apartment with open-concept style, quartz countertops, walk-in closets, and private outdoor space—then start your application online for Preserve at Mill Creek today.</p>",
  "property_contactus_blurb": "<p><strong>Have questions? We’re here to help.</strong> Contact the Preserve at Mill Creek leasing team for details on spacious floor plans, modern apartment finishes, community conveniences, or directions to our Buford location beside Mall of Georgia energy. We’ll help you take the next step toward your new home base.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Preserve at Mill Creek?</strong> Start here for quick answers about the community, leasing, apartment features, amenities, and everyday living. If you need more details about spacious floor plans or resident conveniences, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Start with the way you like to move through a home.</strong> Choose from one-, two-, and three-bedroom apartments at Preserve at Mill Creek, from the streamlined Azalea and larger Magnolia one-bedrooms to the Wisteria two-bedroom and Gardenia three-bedroom layouts.</p><p>Inside, open-concept kitchens, sleek quartz countertops, 9-foot ceilings, ceiling fans, expansive walk-in closets, and private patios or balconies give each floor plan a polished, practical feel. Select homes add details like fireplaces, tray ceilings with crown molding, stainless steel appliances, and nature-trail views. Browse current pricing and availability, compare your favorite layouts, then explore the <a href=\"/amenities\">in-home features</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how your next Buford apartment comes together.</p>",
  "property_gallery_blurb": "<p><strong>Let the photos set the pace.</strong> Browse Preserve at Mill Creek’s gallery and picture the details up close: sunlight across wood-style flooring, open kitchens with sleek quartz surfaces, brushed-nickel lighting, and ceilings that make each room feel airy. Outside, the camera moves from the sparkling pool to shaded gazebos with fire pits, then to the clubhouse, courtyard, dog park, and green trail views that give the community its easygoing Buford feel.</p><p>As you explore each image, look for the moments that match your routine—a balcony for fresh air, a walk-in closet that keeps things organized, or a fitness center and grilling area just steps from home. After the gallery, compare <a href=\"/floor-plans\">available layouts</a>, browse more <a href=\"/amenities\">amenity details</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see it in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore the area around Preserve at Mill Creek.</strong> Use the interactive map to browse available apartments, see where the community sits beside Mall of Georgia energy, and get a clearer feel for nearby shopping, dining, entertainment, and greenway access in the Duluth–Buford area.</p>",
  "property_pets_blurb": "<p><strong>Pet-friendly living with space to roam.</strong> At Preserve at Mill Creek, your daily routine can start with a lap through the <a href=\"/amenities\">large dog park</a>, a stroll along the scenic walking and biking trails, or fresh air from your private patio or balcony. Up to two pets are welcome per home, and there’s no weight limit, giving you more flexibility when choosing the right apartment.</p><p>Inside, open layouts, walk-in closets, and easy-care finishes help keep life with pets feeling organized. Around Buford, nearby pet supply, grooming, and veterinary options add everyday convenience when treats, food, or appointments are on the calendar. Want to picture the walk from home to the dog park? <a href=\"/schedule-a-tour\">Schedule a tour</a> and see the pet-friendly details up close.</p>",
  "property_referafriend_blurb": "<p><strong>Share modern comfort beside Mall of Georgia energy.</strong> Love the roomy floor plans, polished finishes, private patios or balconies, and everyday conveniences at Preserve at Mill Creek? Invite a friend to experience the same easy lifestyle—then use the referral form below to help them find their next home here.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access, made easy.</strong><br>Log in anytime to pay rent, submit maintenance requests, and manage your Preserve at Mill Creek account—part of the 24/7 online resident services that keep everyday routines convenient.</p>",
  "property_reviews_blurb": "<p><strong>See why residents keep choosing Preserve at Mill Creek.</strong> As you explore the reviews, you’ll notice a clear pattern: residents value the quiet setting, beautifully kept grounds, and easy access to the Ivy Creek walking trails. One longtime resident calls the community a “hidden tranquil gem,” while others highlight the peaceful atmosphere and clean, well-maintained surroundings.</p><p>You’ll also hear frequent praise for the team—friendly office staff, responsive maintenance, clear communication, and quick attention to service requests. From community events to everyday upkeep, residents describe a place that feels cared for and connected. Browse the reviews below to hear what living here is like in residents’ own words.</p>",
  "property_created_at": "1773787815313",
  "property_scheduletour_blurb": "<p><strong>See the space, finishes, and everyday ease in person.</strong> Tour Preserve at Mill Creek to experience open-concept kitchens, quartz countertops, walk-in closets, 9-foot ceilings, and private patios or balconies—then picture the pool, clubhouse, fitness center, and connected Buford location as part of your daily rhythm. Schedule your tour today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—your inquiry has been received.</strong><br>Our leasing team will follow up soon. In the meantime, picture spacious one-, two-, or three-bedroom layouts with open-concept kitchens, quartz countertops, walk-in closets, private outdoor space, and everyday conveniences designed around modern comfort beside Mall of Georgia energy.</p>",
  "property_virtualtours_blurb": "<p><strong>Step inside before you stop by.</strong> Explore Preserve at Mill Creek through immersive virtual tours that let you move from the community experience to the details that matter inside each home. Start with the community video and Preserve at Mill Creek tour, then look around the co-working cafe, leasing office, and light-filled fitness center with vaulted ceilings and workout zones.</p><p>When you’re ready to picture daily life, walk through one-, two-, and three-bedroom apartment options, including The Magnolia, The Wisteria, and a spacious three-bedroom layout. Notice the open kitchen flow, bright living areas, crown molding details, walk-in storage, private outdoor connections, and modern finishes that are easier to appreciate in motion. After touring online, compare <a href=\"/floor-plans\">available floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite spaces in person.</p>",
  "property_copyright": "2026 All Rights Reserved. Preserve at Mill Creek",
  "property_seo_title_home": "Preserve at Mill Creek |  Apartments in Buford, GA",
  "property_seo_description_home": "Discover Preserve at Mill Creek in Buford, GA! Choose from stylish one to three-bedroom homes with modern amenities and vibrant community living.",
  "property_seo_title_floorplans": "Floor Plans | Buford, GA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at Preserve at Mill Creek in Buford, GA. From cozy one-bedrooms to spacious three-bedrooms, browse our floor plans to match your style!",
  "property_seo_title_amenities": "Amenities | Buford, GA Apartments for Rent",
  "property_seo_description_amenities": "Experience luxury at Preserve at Mill Creek, Buford, GA! Enjoy stunning amenities, spacious layouts, and vibrant community activities!",
  "property_seo_title_gallery": "Gallery | Apartments in Buford, GA",
  "property_seo_description_gallery": "Envision your dream life at Preserve at Mill Creek in Buford, GA. With stunning amenities and spacious floor plans, your perfect home awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | Preserve at Mill Creek Apartments",
  "property_seo_description_virtualtours": "Step into your future home at Preserve at Mill Creek! Experience our stunning one to three-bedroom apartments in Buford, GA—take a virtual tour today!",
  "property_seo_title_interactivemap": "Interactive Map | Preserve at Mill Creek Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Preserve at Mill Creek, Buford, GA! Use our map to explore stunning floor plans and find your perfect space!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Buford, GA",
  "property_seo_description_neighborhood": "Discover Buford's charm at Preserve at Mill Creek—local favorites, vibrant shops, and parks just steps from your new home. Dive in!",
  "property_seo_title_contact": "Contact Us | Preserve at Mill Creek",
  "property_seo_description_contact": "Reach out to the Preserve at Mill Creek in Buford, GA! Our leasing team is ready to help you find your ideal one, two, or three-bedroom apartment today.",
  "property_seo_title_faqs": "FAQs | Apartments in Buford, GA",
  "property_seo_description_faqs": "Discover life at Preserve at Mill Creek! Enjoy modern amenities, spacious layouts, and a vibrant community in Buford, GA. We're here to help!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Buford, GA",
  "property_seo_description_reviews": "Discover life at Preserve at Mill Creek in Buford, GA! Explore resident reviews and see why our community feels like home with great amenities!",
  "property_seo_title_applynow": "Apply Now | Apartments in Buford, GA",
  "property_seo_description_applynow": "Discover luxury at Preserve at Mill Creek in Buford, GA! Choose spacious 1-3 bedroom apartments with amazing amenities. Lease online now!",
  "property_seo_title_residentaccess": "Resident Access | Preserve at Mill Creek",
  "property_seo_description_residentaccess": "Log in to the Preserve at Mill Creek's resident portal for rent payments, maintenance requests, and community updates—all at your fingertips!",
  "property_seo_title_referafriend": "Refer A Friend | Preserve at Mill Creek",
  "property_seo_description_referafriend": "Share the love at Preserve at Mill Creek in Buford, GA! Refer a friend and cultivate a vibrant community where great neighbors become lifelong friends.",
  "property_seo_title_scheduletour": "Schedule a Tour | Preserve at Mill Creek",
  "property_seo_description_scheduletour": "Experience life at Preserve at Mill Creek in Buford, GA. Schedule a tour today and envision your perfect home in our vibrant, welcoming community!",
  "property_seo_title_privacy": "Privacy Policy | Preserve at Mill Creek",
  "property_seo_description_privacy": "Your privacy matters at Preserve at Mill Creek. Discover how we protect your info and ensure a secure living environment in Buford, GA.",
  "property_seo_title_accessibility": "Website Accessibility | Preserve at Mill Creek",
  "property_seo_description_accessibility": "At Preserve at Mill Creek in Buford, GA, we prioritize digital accessibility for all. Join our community where everyone is welcomed and valued.",
  "property_seo_title_sitemap": "Sitemap | Preserve at Mill Creek",
  "property_seo_description_sitemap": "Unlock the layout of life at Preserve at Mill Creek in Buford, GA. Navigate our sitemap to find the perfect home and community amenities tailored for you.",
  "property_seo_title_thankyou": "Thank You | Preserve at Mill Creek",
  "property_seo_description_thankyou": "Thank you for reaching out! Your journey to comfortable living at Preserve at Mill Creek in Buford, GA, is just beginning. Our team will connect soon!",
  "property_seo_title_pets": "Pet Policy | Apartments in Buford, GA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793651137153",
  "amenities": [
    {
      "id": "custom_4b592910-7b70-4cf9-9dbf-613ca9f26d19",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Stainless Steel Kitchen Appliances*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f6b0ee94-ff2d-4a95-a6ce-2cc21ec750ca",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "external_id": "P000000621",
      "title": "Counters",
      "amount": "0.0000",
      "description": "Sleek Quartz Countertops",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4ad386a4-cb63-47d0-a6ec-28ccb73d7658",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "external_id": "P000000609",
      "title": "Cabinets",
      "amount": "0.0000",
      "description": "Under-Cabinet Lighting",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_842f8fb0-6ced-4c58-b70f-83b64b296ad0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "external_id": "P000000703",
      "title": "W&D Connections",
      "amount": "0.0000",
      "description": "Washer and Dryer Connections",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ce043043-e46d-4349-ba27-f9b4b4571341",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "external_id": "P000000705",
      "title": "Walk-In Closet",
      "amount": "0.0000",
      "description": "Expansive Walk-In Closets",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b6de5620-ea33-40fe-9bd9-d86fae30c9d2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "external_id": "P000000646",
      "title": "Hard Floors",
      "amount": "0.0000",
      "description": "Wood-Style Flooring*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_413ebc60-1d49-4119-ab33-bb5e086281a9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "external_id": "P000000613",
      "title": "Chef`s Kitchen",
      "amount": "0.0000",
      "description": "Open Concept Kitchens",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f60958ad-4b00-48f0-a719-d60e960a5ef6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "external_id": "P000000633",
      "title": "Fire",
      "amount": "0.0000",
      "description": "Fireplace*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c9992ee5-f11e-4a41-bb6f-d883e54f292b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "external_id": "P000000690",
      "title": "Tall Ceilings",
      "amount": "0.0000",
      "description": "Tray Ceilings with Crown Molding*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_22f81791-abcc-43ab-9a9e-459e74d06e31",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "external_id": "P000000636",
      "title": "Fixtures",
      "amount": "0.0000",
      "description": "Modern Brushed Nickel Lighting Fixtures",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cf8de4f0-7867-4c58-8d76-3ddab07ea2b0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "external_id": "P000000641",
      "title": "Garden Tub",
      "amount": "0.0000",
      "description": "Large Garden Tubs",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0e0f8039-4e07-4711-b626-a32bce60f661",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "external_id": "P000000650",
      "title": "Jogging Trail",
      "amount": "0.0000",
      "description": "Nature Trail Views*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7a6e99b4-b4d8-4d34-bae9-4a4b23a44513",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "external_id": "P000000663",
      "title": "Outside Space",
      "amount": "0.0000",
      "description": "Private Patio or Balcony",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f3ea61ca-1ebc-4dee-8596-f3b00870deb4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "external_id": "P000002662",
      "title": "Ceiling fan",
      "amount": "0.0000",
      "description": "9-Foot Ceilings with Ceiling Fans Throughout",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8226d039-3cc0-4cce-b552-b57397d3fb79",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "external_id": "P000000675",
      "title": "Select Homes",
      "amount": "0.0000",
      "description": "*In Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fd3e06aa-1758-429b-afca-b4a5ad947146",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "Sparkling Swimming Pool with Expansive Sundeck",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c2a57ae8-7f41-434d-aa8f-475b204aa71e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "external_id": "P000000642",
      "title": "Gazebo",
      "amount": "0.0000",
      "description": "Poolside Gazebos with Fire Pits",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e19b3c6a-fa1f-4829-82d2-d705480a0c28",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "external_id": "P000000665",
      "title": "Package System",
      "amount": "0.0000",
      "description": "Amazon Package Lockers",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2886d38d-c43c-4b18-82ea-beae4553968d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "external_id": "P000000626",
      "title": "Dog Park",
      "amount": "0.0000",
      "description": "Large Dog Park",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_600ad86e-2c4f-4581-a52b-575c418c5b05",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "external_id": "P000000622",
      "title": "Courtyard",
      "amount": "0.0000",
      "description": "Resident Courtyard & Playground",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a42fb5ad-9773-4152-a52f-316204c72841",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "Fitness Center with Cardio & Strength Equipment",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f41da160-8f6b-4ef3-af64-c7c4cb740102",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "external_id": "P000000610",
      "title": "Car Charging Stations",
      "amount": "0.0000",
      "description": "Electric Vehicle Charging Stations",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ffc24377-a25d-4f0a-a1c5-ebf892dd5cf2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "external_id": "P000000594",
      "title": "Access Gates",
      "amount": "0.0000",
      "description": "Controlled Access Community",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d9cc3720-f2c1-4245-bfc6-040d6fb1b2e8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "external_id": "P000000611",
      "title": "Car Wash",
      "amount": "0.0000",
      "description": "On-Site Car Care Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_55f57e93-3ed5-44d6-a428-1637fac9d351",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "external_id": "P000000644",
      "title": "Grill Area",
      "amount": "0.0000",
      "description": "Outdoor Grilling & BBQ Area",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_46800c6f-aac0-4320-aee9-0211f3f647e0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "external_id": "P000000640",
      "title": "Garages",
      "amount": "0.0000",
      "description": "Attached & Detached Garages Available",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ae6d0052-0e63-4bac-a14b-f09ecb197c79",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "external_id": "P000000656",
      "title": "Laundry Rooms",
      "amount": "0.0000",
      "description": "Onsite Resident Laundry Care Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_76254105-4e2a-44e9-bc0d-7fa958e4f8bf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "external_id": "P000000614",
      "title": "Clubhouse",
      "amount": "0.0000",
      "description": "Modern Resident Clubhouse with Complimentary Wi-Fi",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b2ceea34-c9f3-480e-a68d-ed48af19eca4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "external_id": "P000000706",
      "title": "Walking Trail",
      "amount": "0.0000",
      "description": "Scenic Ivy Creek Biking & Walking Trails",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_20c65d05-29a2-4e24-8080-c5a8accd2318",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "external_id": "P000002561",
      "title": "RentPlus",
      "amount": "0.0000",
      "description": "Credit Building powered by RentPlus",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2e300001-102b-492f-8589-a62e23b72c2d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "external_id": "P000002563",
      "title": "Spruce",
      "amount": "0.0000",
      "description": "Concierge Cleaning Services Available by Spruce",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c73d1f1c-4741-4850-a5ac-49a5fc8fe3c9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9556a3b4-77a9-4bcc-a193-45eb26979d3e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_4d9de284-9b24-4d01-8f21-34dcbdcb2c88",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/01a04903-113c-7755-8981-94d18f1a01ee.webp",
      "image_media": {
        "alt_text": "Modern bathroom with white vanity, large mirror, and subtle decor.",
        "public_id": "01a04903-113c-7755-8981-94d18f1a01ee",
        "storage_key": "property/6767906449167309/01a04903-113c-7755-8981-94d18f1a01ee.webp",
        "width": 1535,
        "height": 1024
      },
      "title": "Apartment",
      "description": "A beautifully appointed bathroom featuring a sleek white vanity, a spacious mirror, and tasteful decorative accents, offering a spa-like experience.",
      "link": "",
      "alt_text": "Modern bathroom with white vanity, large mirror, and subtle decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8178a5af-c68f-4056-9e10-8cf08fea0063",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/01a04902-f2b9-7255-95f5-8593d5e339e0.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment complex with pool, playground, and outdoor seating areas.",
        "public_id": "01a04902-f2b9-7255-95f5-8593d5e339e0",
        "storage_key": "property/6767906449167309/01a04902-f2b9-7255-95f5-8593d5e339e0.webp",
        "width": 1099,
        "height": 727
      },
      "title": "Community",
      "description": "Discover a vibrant community with a sparkling pool, engaging playground, and ample outdoor seating. Perfect for relaxation and recreation.",
      "link": "",
      "alt_text": "Aerial view of apartment complex with pool, playground, and outdoor seating areas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_94b5dc9e-0828-48c2-95a2-01fa2e40495a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/01a04902-f2d3-7609-bf28-548c198cb889.webp",
      "image_media": {
        "alt_text": "Preserve at Mill Creek apartment homes monument sign surrounded by lush landscaping.",
        "public_id": "01a04902-f2d3-7609-bf28-548c198cb889",
        "storage_key": "property/6767906449167309/01a04902-f2d3-7609-bf28-548c198cb889.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Welcome to Preserve at Mill Creek Apartment Homes. Discover a beautiful community with well-maintained grounds and an inviting entrance.",
      "link": "",
      "alt_text": "Preserve at Mill Creek apartment homes monument sign surrounded by lush landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1b33e490-a172-4e3d-b85a-026665079416",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/01a04902-e892-7458-8930-2c94b779f2fc.webp",
      "image_media": {
        "alt_text": "Modern living room with green sofa, black leather armchairs, and dining area visible in background.",
        "public_id": "01a04902-e892-7458-8930-2c94b779f2fc",
        "storage_key": "property/6767906449167309/01a04902-e892-7458-8930-2c94b779f2fc.webp",
        "width": 1535,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a plush green sofa, contemporary leather armchairs, and a spacious open-plan layout connecting to the kitchen and dining area.",
      "link": "",
      "alt_text": "Modern living room with green sofa, black leather armchairs, and dining area visible in background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_06db245d-4d9e-4e4c-a9be-1b408970c2a3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/01a04902-de52-70b2-acca-7ad82b2ac05a.webp",
      "image_media": {
        "alt_text": "Balcony with two chairs, a small table, and a rug.",
        "public_id": "01a04902-de52-70b2-acca-7ad82b2ac05a",
        "storage_key": "property/6767906449167309/01a04902-de52-70b2-acca-7ad82b2ac05a.webp",
        "width": 1535,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee on your private balcony, complete with comfortable seating and scenic views.",
      "link": "",
      "alt_text": "Balcony with two chairs, a small table, and a rug.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f7056203-231b-42f2-912a-3d2f76293ad0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/01a04902-e12e-7720-b971-56d58001a908.webp",
      "image_media": {
        "alt_text": "Wooden boardwalk through a wooded area with autumn foliage.",
        "public_id": "01a04902-e12e-7720-b971-56d58001a908",
        "storage_key": "property/6767906449167309/01a04902-e12e-7720-b971-56d58001a908.webp",
        "width": 1024,
        "height": 576
      },
      "title": "Community",
      "description": "Enjoy a stroll on the scenic boardwalk, surrounded by the vibrant colors of autumn trees and lush greenery.",
      "link": "",
      "alt_text": "Wooden boardwalk through a wooded area with autumn foliage.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8982eb3d-06e6-4766-9401-de7eaac3011d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/01a04902-e11d-722d-a880-4b8e018ce545.webp",
      "image_media": {
        "alt_text": "Living room with a green couch, coffee table, and armchair. An open doorway shows a glimpse of a bedroom.",
        "public_id": "01a04902-e11d-722d-a880-4b8e018ce545",
        "storage_key": "property/6767906449167309/01a04902-e11d-722d-a880-4b8e018ce545.webp",
        "width": 1537,
        "height": 1023
      },
      "title": "Apartment",
      "description": "Relax in this beautifully appointed living room featuring a plush green sofa, a stylish coffee table, and a comfortable armchair. The open layout provides a view into the adjacent bedroom, creating a sense of spaciousness.",
      "link": "",
      "alt_text": "Living room with a green couch, coffee table, and armchair. An open doorway shows a glimpse of a bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c984f8f8-ed45-4874-a318-e6e22e24ddfa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/01a04902-e5cc-751d-8b51-20850e25622f.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and cabanas.",
        "public_id": "01a04902-e5cc-751d-8b51-20850e25622f",
        "storage_key": "property/6767906449167309/01a04902-e5cc-751d-8b51-20850e25622f.webp",
        "width": 1024,
        "height": 576
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by the resort-style swimming pool, complete with comfortable lounge chairs and shaded cabanas.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and cabanas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_092c54e4-20bb-41a3-a3fd-d5a3017dbd9e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/01a04902-e12b-7038-bca6-69976d0345a5.webp",
      "image_media": {
        "alt_text": "Modern dining area with a large wooden table and chairs, and a lounge area with booth seating.",
        "public_id": "01a04902-e12b-7038-bca6-69976d0345a5",
        "storage_key": "property/6767906449167309/01a04902-e12b-7038-bca6-69976d0345a5.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Enjoy a meal or casual gathering in our stylish dining and lounge space, perfect for residents.",
      "link": "",
      "alt_text": "Modern dining area with a large wooden table and chairs, and a lounge area with booth seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6a5bd85e-e5e8-4e7d-bec2-a81ef6e54eb9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/01a04902-df82-723c-97ca-ee517b12b057.webp",
      "image_media": {
        "alt_text": "Treadmills and weight machines in a well-lit gym with large mirrors and ceiling fans.",
        "public_id": "01a04902-df82-723c-97ca-ee517b12b057",
        "storage_key": "property/6767906449167309/01a04902-df82-723c-97ca-ee517b12b057.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio equipment and weights, perfect for your active lifestyle.",
      "link": "",
      "alt_text": "Treadmills and weight machines in a well-lit gym with large mirrors and ceiling fans.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_214a3671-9e34-4328-b7d9-139a4aa36c81",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/01a04902-dcd0-703c-971b-eec9a82d9755.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and island.",
        "public_id": "01a04902-dcd0-703c-971b-eec9a82d9755",
        "storage_key": "property/6767906449167309/01a04902-dcd0-703c-971b-eec9a82d9755.webp",
        "width": 1448,
        "height": 1086
      },
      "title": "Apartment",
      "description": "Gourmet kitchen with white countertops, stainless steel appliances including a dishwasher and refrigerator, and ample cabinet space.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bf8636fb-d2cb-4ab2-bdac-874015ff1bfe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/01a04902-cb37-77eb-8756-eb62cc88167d.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with attached garages.",
        "public_id": "01a04902-cb37-77eb-8756-eb62cc88167d",
        "storage_key": "property/6767906449167309/01a04902-cb37-77eb-8756-eb62cc88167d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to our beautiful apartment community, featuring modern buildings with convenient attached garages.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with attached garages.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_364194d5-c324-40de-9995-19f0b696bd4c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/01a04902-c6de-732e-be60-15aa435a42af.webp",
      "image_media": {
        "alt_text": "Covered outdoor seating area with a fire pit and chairs.",
        "public_id": "01a04902-c6de-732e-be60-15aa435a42af",
        "storage_key": "property/6767906449167309/01a04902-c6de-732e-be60-15aa435a42af.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Relax and unwind in our beautiful outdoor seating area, complete with a cozy fire pit and comfortable chairs.",
      "link": "",
      "alt_text": "Covered outdoor seating area with a fire pit and chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_201cd0e2-910b-4270-a87f-b809c9cda895",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/01a04902-c9bc-748d-a8d0-6d20211f09ac.webp",
      "image_media": {
        "alt_text": "Living room with green sofa, coffee table, and black chairs.",
        "public_id": "01a04902-c9bc-748d-a8d0-6d20211f09ac",
        "storage_key": "property/6767906449167309/01a04902-c9bc-748d-a8d0-6d20211f09ac.webp",
        "width": 1448,
        "height": 1086
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a plush green sofa, a round coffee table, and comfortable seating. Perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Living room with green sofa, coffee table, and black chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c3551335-a417-4f3c-bb22-fb43f5c06f02",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/01a04902-c440-74da-b9be-096cf320089d.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment complex with a resort-style pool and lounge chairs.",
        "public_id": "01a04902-c440-74da-b9be-096cf320089d",
        "storage_key": "property/6767906449167309/01a04902-c440-74da-b9be-096cf320089d.webp",
        "width": 1099,
        "height": 729
      },
      "title": "Community",
      "description": "Enjoy the resort-style swimming pool and ample lounge seating at this beautiful apartment community.",
      "link": "",
      "alt_text": "Exterior view of apartment complex with a resort-style pool and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_74c0b68a-d76e-42ab-896a-b521bf7dca6c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/01a04902-c947-7650-8d72-555b248c564f.webp",
      "image_media": {
        "alt_text": "Walk-in closet with built-in shelving, baskets, towels, and a handbag.",
        "public_id": "01a04902-c947-7650-8d72-555b248c564f",
        "storage_key": "property/6767906449167309/01a04902-c947-7650-8d72-555b248c564f.webp",
        "width": 1537,
        "height": 1023
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring ample shelving for storage. Organize your linens, accessories, and more in this convenient closet space.",
      "link": "",
      "alt_text": "Walk-in closet with built-in shelving, baskets, towels, and a handbag.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_37e71f56-7aa2-4af4-9220-d3a989c04ba2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/01a04902-c55c-713b-8d9a-b2b6f3a6efcb.webp",
      "image_media": {
        "alt_text": "Spacious bedroom with a king-sized bed, dresser, and closet.",
        "public_id": "01a04902-c55c-713b-8d9a-b2b6f3a6efcb",
        "storage_key": "property/6767906449167309/01a04902-c55c-713b-8d9a-b2b6f3a6efcb.webp",
        "width": 1535,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Relax in comfort in our spacious bedrooms, featuring plush carpeting, ample storage, and elegant decor.",
      "link": "",
      "alt_text": "Spacious bedroom with a king-sized bed, dresser, and closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_38c9a110-a45d-410d-aabc-03b7ae9c82b4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/01a04902-c55d-7088-8b54-4c3d8bf6e39f.webp",
      "image_media": {
        "alt_text": "Resort-style pool and lounge area with cabana and clubhouse.",
        "public_id": "01a04902-c55d-7088-8b54-4c3d8bf6e39f",
        "storage_key": "property/6767906449167309/01a04902-c55d-7088-8b54-4c3d8bf6e39f.webp",
        "width": 1024,
        "height": 576
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim or relax by the sparkling pool, complete with a cabana and outdoor seating. Adjacent to the clubhouse, this amenity offers the perfect spot for leisure.",
      "link": "",
      "alt_text": "Resort-style pool and lounge area with cabana and clubhouse.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8c70a0e7-cd2a-43b4-b8d7-58fc2d356768",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/01a04902-c36b-761a-b455-412cec3cce29.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical machines, weight racks, and multi-gym.",
        "public_id": "01a04902-c36b-761a-b455-412cec3cce29",
        "storage_key": "property/6767906449167309/01a04902-c36b-761a-b455-412cec3cce29.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center features cardio equipment, free weights, and strength training machines to help you stay active and healthy.",
      "link": "",
      "alt_text": "Fitness center with treadmills, elliptical machines, weight racks, and multi-gym.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7ed532c5-3049-428c-a5df-4ebd9db70cf4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/01a04902-c43f-72c2-814f-8570a7c244c9.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a view into the living room.",
        "public_id": "01a04902-c43f-72c2-814f-8570a7c244c9",
        "storage_key": "property/6767906449167309/01a04902-c43f-72c2-814f-8570a7c244c9.webp",
        "width": 1535,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances, ample cabinet storage, and a seamless flow into the living area.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a view into the living room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1ea6f55e-df78-4d66-986a-76b48731eb24",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/01a04902-c36d-721e-964c-fb8920b75cfa.webp",
      "image_media": {
        "alt_text": "Modern bathroom with white vanity, soaking tub, and horse-themed art.",
        "public_id": "01a04902-c36d-721e-964c-fb8920b75cfa",
        "storage_key": "property/6767906449167309/01a04902-c36d-721e-964c-fb8920b75cfa.webp",
        "width": 1537,
        "height": 1023
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed bathroom, featuring a spacious vanity, elegant soaking tub, and tasteful decor.",
      "link": "",
      "alt_text": "Modern bathroom with white vanity, soaking tub, and horse-themed art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_80167979cf8dd653e5994ecb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "Space VD01H, 3333 Buford Dr, Buford, GA 30519, USA",
      "poi_short_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_long_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019f14df-c8f8-744b-ac29-7bec2f583ebe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14df-c8f8-744b-ac29-7bec2f583ebe",
        "storage_key": "property/6767906449167309/019f14df-c8f8-744b-ac29-7bec2f583ebe.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.thecheesecakefactory.com/ga/buford-172.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=3561297674772165390&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "34.0636337",
      "poi_longitude": "-83.9834374",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 770-831-4710",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0277-744b-aec6-9662b5f4ee22.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0277-744b-aec6-9662b5f4ee22",
        "storage_key": "property/6767906449167309/019d02f8-0277-744b-aec6-9662b5f4ee22.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2fzQNUOU9YgRDjM43F1FbDE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_3c9c0fb7caf4150389e2ed80",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "P.F. Chang's",
      "poi_type": "Restaurants",
      "poi_address": "3333 Buford Dr Space VA03, Buford, GA 30519, USA",
      "poi_short_description": "Family-friendly chain offering creative takes on Asian fare in a striking space.",
      "poi_long_description": "Family-friendly chain offering creative takes on Asian fare in a striking space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019dabc5-751d-7158-8125-63fd72d340c0.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of P.F. Chang's restaurant with large horse statues and a welcome sign.",
        "public_id": "019dabc5-751d-7158-8125-63fd72d340c0",
        "storage_key": "property/6767906449167309/019dabc5-751d-7158-8125-63fd72d340c0.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://locations.pfchangs.com/ga/buford/3333-buford-dr-space-va03.html?utm_source=google_gbp&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=5800298301687429041&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pf-changs",
      "poi_latitude": "34.0642751",
      "poi_longitude": "-83.9828067",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 678-546-9005",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0277-744b-aec6-9662b5f4ee22.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0277-744b-aec6-9662b5f4ee22",
        "storage_key": "property/6767906449167309/019d02f8-0277-744b-aec6-9662b5f4ee22.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCZbP21qU9YgRsXdh95LMflA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "ec_5123eab22bc85a018b8c707c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Tin Lizzy's Cantina",
      "poi_type": "Restaurants",
      "poi_address": "3333 Buford Dr, Buford, GA 30519, USA",
      "poi_short_description": "Laid-back, vibrant cantina with live music serving Tex-Mex food, margaritas, beer & wine.",
      "poi_long_description": "Laid-back, vibrant cantina with live music serving Tex-Mex food, margaritas, beer & wine.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f7-8a97-721b-bc17-5d659fccd396.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02f7-8a97-721b-bc17-5d659fccd396",
        "storage_key": "property/6767906449167309/019d02f7-8a97-721b-bc17-5d659fccd396.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://tinlizzyscantina.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13838017842443075119&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tin-lizzys-cantina",
      "poi_latitude": "34.0643558",
      "poi_longitude": "-83.9829505",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 678-805-2380",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0277-744b-aec6-9662b5f4ee22.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0277-744b-aec6-9662b5f4ee22",
        "storage_key": "property/6767906449167309/019d02f8-0277-744b-aec6-9662b5f4ee22.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJg6yK3FqU9YgRLz5WJumDCsA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tex_mex_restaurant"
    },
    {
      "id": "ec_56c14a72b4045412810c93cb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Ted's Montana Grill",
      "poi_type": "Restaurants",
      "poi_address": "1680 Mall of Georgia Blvd, Buford, GA 30519, USA",
      "poi_short_description": "Old West-style steakhouse chain known for its burgers & chops made from bison.",
      "poi_long_description": "Old West-style steakhouse chain known for its burgers & chops made from bison.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019dabc5-756b-76ef-94d1-e0c817fb0ad4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dabc5-756b-76ef-94d1-e0c817fb0ad4",
        "storage_key": "property/6767906449167309/019dabc5-756b-76ef-94d1-e0c817fb0ad4.webp",
        "width": 600,
        "height": 450
      },
      "poi_business_url": "https://www.tedsmontanagrill.com/tmg008.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=10868507535835756453&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "teds-montana-grill",
      "poi_latitude": "34.0625649",
      "poi_longitude": "-83.99413",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 678-546-3631",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0277-744b-aec6-9662b5f4ee22.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0277-744b-aec6-9662b5f4ee22",
        "storage_key": "property/6767906449167309/019d02f8-0277-744b-aec6-9662b5f4ee22.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJfY8i3EeU9YgRpXclIAWy1JY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_c28aa133f3bd7e32ea5258e2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "la Madeleine",
      "poi_type": "Restaurants",
      "poi_address": "1795 Mall of Georgia Blvd, Buford, GA 30519, USA",
      "poi_short_description": "Quaint French cafe chain serving rustic country fare, espresso & fresh-baked baguettes.",
      "poi_long_description": "Quaint French cafe chain serving rustic country fare, espresso & fresh-baked baguettes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019f14e1-d956-726f-9cc8-c80a171f4b96.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e1-d956-726f-9cc8-c80a171f4b96",
        "storage_key": "property/6767906449167309/019f14e1-d956-726f-9cc8-c80a171f4b96.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://lamadeleine.com/locations/buford",
      "poi_directions_map_url": "https://maps.google.com/?cid=14868457441422685000&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-madeleine",
      "poi_latitude": "34.0615989",
      "poi_longitude": "-83.9918089",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 470-589-1528",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0277-744b-aec6-9662b5f4ee22.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0277-744b-aec6-9662b5f4ee22",
        "storage_key": "property/6767906449167309/019d02f8-0277-744b-aec6-9662b5f4ee22.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ-XJmUiU9YgRSDMDOkRfV84",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_93ba5f6d2c26528b6b88abad",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "The Flying Biscuit Cafe",
      "poi_type": "Restaurants",
      "poi_address": "2660 Mall of Georgia Blvd Ste 100C, Buford, GA 30519, USA",
      "poi_short_description": "Branch of a laid-back chain known for Southern food & all-day breakfast selections.",
      "poi_long_description": "Branch of a laid-back chain known for Southern food & all-day breakfast selections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019f14e1-d118-77ad-aef2-b6f2d7585f00.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e1-d118-77ad-aef2-b6f2d7585f00",
        "storage_key": "property/6767906449167309/019f14e1-d118-77ad-aef2-b6f2d7585f00.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://flyingbiscuit.com/locations-2/buford/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16228595369079468444&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-flying-biscuit-cafe",
      "poi_latitude": "34.0658873",
      "poi_longitude": "-83.9754597",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 470-326-3695",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0277-744b-aec6-9662b5f4ee22.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0277-744b-aec6-9662b5f4ee22",
        "storage_key": "property/6767906449167309/019d02f8-0277-744b-aec6-9662b5f4ee22.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJpTmio16V9YgRnPGHYYGNN-E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_e566b337a3b84072d87686d3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Snooze, an A.M. Eatery",
      "poi_type": "Restaurants",
      "poi_address": "2925 Buford Dr Ste 1100, Buford, GA 30519, USA",
      "poi_short_description": "Vibrant, retro chain serving a seasonal menu of creative breakfast & lunch fare, plus cocktails.",
      "poi_long_description": "Vibrant, retro chain serving a seasonal menu of creative breakfast & lunch fare, plus cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019f14e1-ccda-7579-960d-b7a15016ac28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e1-ccda-7579-960d-b7a15016ac28",
        "storage_key": "property/6767906449167309/019f14e1-ccda-7579-960d-b7a15016ac28.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "https://www.snoozeeatery.com/restaurant/georgia/mall-of-georgia/?utm_source=Google&utm_medium=BusinessListing",
      "poi_directions_map_url": "https://maps.google.com/?cid=3750620972808524705&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "snooze-an-am-eatery",
      "poi_latitude": "34.0514613",
      "poi_longitude": "-83.9933655",
      "poi_miles_from_property": "9.9 mi",
      "poi_walking_minutes": "3 hours 38 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 470-822-3590",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0277-744b-aec6-9662b5f4ee22.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0277-744b-aec6-9662b5f4ee22",
        "storage_key": "property/6767906449167309/019d02f8-0277-744b-aec6-9662b5f4ee22.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJDX_FUbCV9YgRodNhM-fhDDQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "ec_85eb48cf09be5ad9bee49548",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Paris Baguette",
      "poi_type": "Restaurants",
      "poi_address": "2925 Buford Dr #200, Buford, GA 30519, USA",
      "poi_short_description": "Friendly bakery cafe chain for breads, sweets, pastries and cakes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019f14e1-d90a-777c-870b-f134e7b211a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e1-d90a-777c-870b-f134e7b211a6",
        "storage_key": "property/6767906449167309/019f14e1-d90a-777c-870b-f134e7b211a6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://parisbaguette.com/locations/ga/buford/2925-buford-drive/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4259141633205075998&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "paris-baguette",
      "poi_latitude": "34.0514904",
      "poi_longitude": "-83.992115",
      "poi_miles_from_property": "9.9 mi",
      "poi_walking_minutes": "3 hours 38 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 470-266-2084",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0277-744b-aec6-9662b5f4ee22.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0277-744b-aec6-9662b5f4ee22",
        "storage_key": "property/6767906449167309/019d02f8-0277-744b-aec6-9662b5f4ee22.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJgwkW6z-V9YgRHgBE37-CGzs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "ec_8e0ba7e67453edeabd08c59e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Mikado Sushi",
      "poi_type": "Restaurants",
      "poi_address": "1880 Mall of Georgia Blvd, Buford, GA 30519, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019f14e1-d911-7074-a99d-03245bbe8e40.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e1-d911-7074-a99d-03245bbe8e40",
        "storage_key": "property/6767906449167309/019f14e1-d911-7074-a99d-03245bbe8e40.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4230229987475640487&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mikado-sushi",
      "poi_latitude": "34.0616957",
      "poi_longitude": "-83.9890169",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 470-238-3920",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0277-744b-aec6-9662b5f4ee22.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0277-744b-aec6-9662b5f4ee22",
        "storage_key": "property/6767906449167309/019d02f8-0277-744b-aec6-9662b5f4ee22.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJccReWgCV9YgRp9CwycLLtDo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "ec_7e53c428de9389d43fdbc490",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Moe's Southwest Grill",
      "poi_type": "Restaurants",
      "poi_address": "1825 Mall of Georgia Blvd, Buford, GA 30519, USA",
      "poi_short_description": "Counter-serve chain dishing up Southwestern staples from burritos to nachos in lively environs.",
      "poi_long_description": "Counter-serve chain dishing up Southwestern staples from burritos to nachos in lively environs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019f14e1-e192-74ab-9040-2c5cf7e156b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e1-e192-74ab-9040-2c5cf7e156b6",
        "storage_key": "property/6767906449167309/019f14e1-e192-74ab-9040-2c5cf7e156b6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.moes.com/ga/buford/1825-mall-of-georgia-blvd?utm_source=google&utm_medium=organic&utm_campaign=locations_partner",
      "poi_directions_map_url": "https://maps.google.com/?cid=12750319287750641293&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "moes-southwest-grill",
      "poi_latitude": "34.0609987",
      "poi_longitude": "-83.99064469999999",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 770-614-7556",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0277-744b-aec6-9662b5f4ee22.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0277-744b-aec6-9662b5f4ee22",
        "storage_key": "property/6767906449167309/019d02f8-0277-744b-aec6-9662b5f4ee22.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJv719tUiU9YgRjUYwj9Y78rA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_3f75c8e6214ab219eff4cd32",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Antoinette's Cafe",
      "poi_type": "Restaurants",
      "poi_address": "1630 Buford Hwy NE #2, Buford, GA 30518, USA",
      "poi_short_description": "Casual, cozy sandwich shop offering smoothies, avocado toast and teas, as well as vegan burgers.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019f14e1-df30-7101-89fb-d87bad655195.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e1-df30-7101-89fb-d87bad655195",
        "storage_key": "property/6767906449167309/019f14e1-df30-7101-89fb-d87bad655195.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.antoinettescafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2017680536152310918&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "antoinettes-cafe",
      "poi_latitude": "34.099343",
      "poi_longitude": "-84.010635",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 678-765-6446",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0277-744b-aec6-9662b5f4ee22.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0277-744b-aec6-9662b5f4ee22",
        "storage_key": "property/6767906449167309/019d02f8-0277-744b-aec6-9662b5f4ee22.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQT6nKPmT9YgRhgSU68E9ABw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_acf704992c53ff02784d11c1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Cork It Buford - Wine and Charcuterie Buford",
      "poi_type": "Restaurants",
      "poi_address": "79 E Main St NE, Buford, GA 30518, USA",
      "poi_short_description": "Relaxed wine bar featuring a wide selection of local and imported bottles and wine flights.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019f14e1-e1d6-70a1-96db-0577fd561a6e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e1-e1d6-70a1-96db-0577fd561a6e",
        "storage_key": "property/6767906449167309/019f14e1-e1d6-70a1-96db-0577fd561a6e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://corkitbuford.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15909655402960809395&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cork-it-buford---wine-and-charcuterie-buford",
      "poi_latitude": "34.1204761",
      "poi_longitude": "-84.0049885",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 678-765-2549",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019f14e2-c2e4-73b5-84e4-f413bbce0d1e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-c2e4-73b5-84e4-f413bbce0d1e",
        "storage_key": "property/6767906449167309/019f14e2-c2e4-73b5-84e4-f413bbce0d1e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaZr7G-2T9YgRs21ayEtzytw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wine_bar"
    },
    {
      "id": "ec_28b5edafbe84faf7f1ed1636",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Sperata",
      "poi_type": "Restaurants",
      "poi_address": "9 E Main St NE, Buford, GA 30518, USA",
      "poi_short_description": "Fine dining destination featuring innovative recipes inspired by the executive chef’s world travels.",
      "poi_long_description": "Fine dining destination featuring innovative recipes inspired by the executive chef’s world travels.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019f14e1-e8ee-76bb-80a5-b6ee847a10f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e1-e8ee-76bb-80a5-b6ee847a10f0",
        "storage_key": "property/6767906449167309/019f14e1-e8ee-76bb-80a5-b6ee847a10f0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5347775054887240042&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sperata",
      "poi_latitude": "34.1200197",
      "poi_longitude": "-84.0058116",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0277-744b-aec6-9662b5f4ee22.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0277-744b-aec6-9662b5f4ee22",
        "storage_key": "property/6767906449167309/019d02f8-0277-744b-aec6-9662b5f4ee22.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJm9drycKT9YgRasE_JRQdN0o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_fb326f832bba5af7a973158e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Taqueria El Rey Del Pastor",
      "poi_type": "Restaurants",
      "poi_address": "3260 Buford Dr #60, Buford, GA 30519, USA",
      "poi_short_description": "Casual eatery whipping up tacos al pastor, quesadillas and other traditional Mexican dishes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019f14e1-f0c6-75fa-ac1f-68d923e5d25d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e1-f0c6-75fa-ac1f-68d923e5d25d",
        "storage_key": "property/6767906449167309/019f14e1-f0c6-75fa-ac1f-68d923e5d25d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.elreydelpastor.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10559202855652759683&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "taqueria-el-rey-del-pastor",
      "poi_latitude": "34.0667654",
      "poi_longitude": "-83.98825590000001",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 470-655-7951",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0277-744b-aec6-9662b5f4ee22.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0277-744b-aec6-9662b5f4ee22",
        "storage_key": "property/6767906449167309/019d02f8-0277-744b-aec6-9662b5f4ee22.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJhWn73XqV9YgRgxh5Wg3TiZI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_fdda7b2644795621f9e59f25",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "G Sister Restaurant & Kettle corn",
      "poi_type": "Restaurants",
      "poi_address": "6986 McEver Rd, Buford, GA 30518, USA",
      "poi_short_description": "Authentic Mexican joint with casual seating, making tacos, burritos, and other meals.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019f14e1-f257-776d-9c89-ed4261f210c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e1-f257-776d-9c89-ed4261f210c2",
        "storage_key": "property/6767906449167309/019f14e1-f257-776d-9c89-ed4261f210c2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4859643094753908835&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "g-sister-restaurant--kettle-corn",
      "poi_latitude": "34.1500936",
      "poi_longitude": "-83.9734096",
      "poi_miles_from_property": "8.3 mi",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 470-326-5032",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0277-744b-aec6-9662b5f4ee22.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0277-744b-aec6-9662b5f4ee22",
        "storage_key": "property/6767906449167309/019d02f8-0277-744b-aec6-9662b5f4ee22.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJmUz79feS9YgRY5j8raXrcEM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_f0dd4d882fa4fa5d16f6a8c7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Costco Wholesale",
      "poi_type": "Shopping & Retail",
      "poi_address": "1550 Mall of Georgia Blvd NE, Buford, GA 30519, USA",
      "poi_short_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_long_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019f14e1-ecec-7598-84d2-5170e9e0eacb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e1-ecec-7598-84d2-5170e9e0eacb",
        "storage_key": "property/6767906449167309/019f14e1-ecec-7598-84d2-5170e9e0eacb.webp",
        "width": 1280,
        "height": 714
      },
      "poi_business_url": "https://www.costco.com/warehouse-locations/buford-GA-366.html?utm_term=KW&utm_campaign=Homepage&utm_medium=GMB&utm_source=Google&utm_content=Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=17096418785153045031&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "costco-wholesale",
      "poi_latitude": "34.06245070000001",
      "poi_longitude": "-83.9958882",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 678-288-3009",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-028c-76ff-bd6a-98d5ef201468.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-028c-76ff-bd6a-98d5ef201468",
        "storage_key": "property/6767906449167309/019d02f8-028c-76ff-bd6a-98d5ef201468.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJu_lXC0iU9YgRJ9Jc7E2uQu0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "warehouse_store"
    },
    {
      "id": "ec_bd2e43a88f1355f0a48a2e24",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "1705 Mall of Georgia Blvd Ste 3, Buford, GA 30519, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019dabc5-a504-733c-b75b-e20e8052e0d8.webp",
      "poi_featured_image_media": {
        "alt_text": "ALDI grocery store logo and building exterior",
        "public_id": "019dabc5-a504-733c-b75b-e20e8052e0d8",
        "storage_key": "property/6767906449167309/019dabc5-a504-733c-b75b-e20e8052e0d8.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://info.aldi.us/stores/l/ga/buford/1705-mall-of-ga-blvd-ste-3/l977",
      "poi_directions_map_url": "https://maps.google.com/?cid=5920262600307272049&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "34.06024",
      "poi_longitude": "-83.99364",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0284-739d-8fb5-a92f5f7f7d38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0284-739d-8fb5-a92f5f7f7d38",
        "storage_key": "property/6767906449167309/019d02f8-0284-739d-8fb5-a92f5f7f7d38.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc2H9vxaV9YgRcWlY1Hf_KFI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_60d55ee3b9731c3c9fb702fe",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "3300 Hamilton Mill Rd, Buford, GA 30519, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019f14e1-f12a-731f-90f1-26cde530a9af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e1-f12a-731f-90f1-26cde530a9af",
        "storage_key": "property/6767906449167309/019f14e1-f12a-731f-90f1-26cde530a9af.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/ga/buford/hamilton-ridge/011/00494?cid=loc_01100494_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=15210643702312753381&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "34.0931571",
      "poi_longitude": "-83.9374617",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 770-614-1081",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0284-739d-8fb5-a92f5f7f7d38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0284-739d-8fb5-a92f5f7f7d38",
        "storage_key": "property/6767906449167309/019d02f8-0284-739d-8fb5-a92f5f7f7d38.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNyOLDlaT9YgR5VhimdsPF9M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_3c45a281fb45cdd6b71dd74a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "3205 Woodward Crossing Blvd Ste B, Buford, GA 30519, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019f14e1-f7dd-750f-a688-a0b1d81711c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e1-f7dd-750f-a688-a0b1d81711c8",
        "storage_key": "property/6767906449167309/019f14e1-f7dd-750f-a688-a0b1d81711c8.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.cvs.com/store-locator/buford-ga-pharmacies/3205-woodward-crossing-blvd-ste-b-buford-ga-30519/storeid=16561?WT.mc_id=LS_GOOGLE_RX_16561",
      "poi_directions_map_url": "https://maps.google.com/?cid=11595622792104411839&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "34.0704122",
      "poi_longitude": "-83.9817372",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 678-482-6528",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0997-7262-81a0-7886b7d2727f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0997-7262-81a0-7886b7d2727f",
        "storage_key": "property/6767906449167309/019d02f8-0997-7262-81a0-7886b7d2727f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeye_R1yU9YgRv4LOQH7t66A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_a6ef677c87566565a6098d3c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Mall of Georgia",
      "poi_type": "Shopping & Retail",
      "poi_address": "3333 Buford Dr, Buford, GA 30519, USA",
      "poi_short_description": "Landmark mall with grand architecture & 200+ stores on 3 levels, plus a cinema & kids’ play area.",
      "poi_long_description": "Landmark mall with grand architecture & 200+ stores on 3 levels, plus a cinema & kids’ play area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019dabba-2468-768c-bf42-49f6485709dc.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of the Mall of Georgia with Regal Cinemas signage.",
        "public_id": "019dabba-2468-768c-bf42-49f6485709dc",
        "storage_key": "property/6767906449167309/019dabba-2468-768c-bf42-49f6485709dc.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.simon.com/mall/mall-of-georgia",
      "poi_directions_map_url": "https://maps.google.com/?cid=11636229521613497056&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mall-of-georgia",
      "poi_latitude": "34.0651406",
      "poi_longitude": "-83.9844837",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 678-482-8788",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-028c-76ff-bd6a-98d5ef201468.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-028c-76ff-bd6a-98d5ef201468",
        "storage_key": "property/6767906449167309/019d02f8-028c-76ff-bd6a-98d5ef201468.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJf04EMFuU9YgR4KKvOBkxfKE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_a3002dbd32982e97bbe4bf4c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "3205 Woodward Crossing Blvd Ste B, Buford, GA 30519, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019dabc5-c2a8-7144-b9c1-b70a28aaabce.webp",
      "poi_featured_image_media": {
        "alt_text": "The iconic Target logo and entrance to a Target store.",
        "public_id": "019dabc5-c2a8-7144-b9c1-b70a28aaabce",
        "storage_key": "property/6767906449167309/019dabc5-c2a8-7144-b9c1-b70a28aaabce.webp",
        "width": 3072,
        "height": 1728
      },
      "poi_business_url": "https://www.target.com/sl/buford/1206",
      "poi_directions_map_url": "https://maps.google.com/?cid=4618649763597373896&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "34.0701011",
      "poi_longitude": "-83.98178209999999",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 678-482-2367",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-028c-76ff-bd6a-98d5ef201468.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-028c-76ff-bd6a-98d5ef201468",
        "storage_key": "property/6767906449167309/019d02f8-028c-76ff-bd6a-98d5ef201468.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJeye_R1yU9YgRyNEpRX29GEA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_18f6262e809ed763ec8dad2a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Sam's Club",
      "poi_type": "Shopping & Retail",
      "poi_address": "3383 Buford Dr, Buford, GA 30519, USA",
      "poi_short_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_long_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019f14e1-fae3-71b9-b382-95a8bed6d956.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e1-fae3-71b9-b382-95a8bed6d956",
        "storage_key": "property/6767906449167309/019f14e1-fae3-71b9-b382-95a8bed6d956.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.samsclub.com/club/4780-buford-ga",
      "poi_directions_map_url": "https://maps.google.com/?cid=6164085027405667874&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sams-club",
      "poi_latitude": "34.0729817",
      "poi_longitude": "-83.98095409999999",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 770-831-7122",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-028c-76ff-bd6a-98d5ef201468.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-028c-76ff-bd6a-98d5ef201468",
        "storage_key": "property/6767906449167309/019d02f8-028c-76ff-bd6a-98d5ef201468.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJay9CZmeU9YgRIp7Rd6w6i1U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "ec_99b5eb1ef392feaa37386681",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "3795 Buford Dr, Buford, GA 30519, USA",
      "poi_short_description": "Department store chain supplying groceries, clothing, home furnishings, electronics, and other merchandise.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f7-a91e-76b9-be91-cad14ef367f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02f7-a91e-76b9-be91-cad14ef367f5",
        "storage_key": "property/6767906449167309/019d02f7-a91e-76b9-be91-cad14ef367f5.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/1314-buford-ga/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=2706025387807216191&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "34.0884752",
      "poi_longitude": "-83.9899961",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 770-271-8210",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-028c-76ff-bd6a-98d5ef201468.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-028c-76ff-bd6a-98d5ef201468",
        "storage_key": "property/6767906449167309/019d02f8-028c-76ff-bd6a-98d5ef201468.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJQ3SRF3KU9YgRPxJwycC7jSU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_cc07cf172f9bb36f78767bbe",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Publix Super Market at Holland Point",
      "poi_type": "Shopping & Retail",
      "poi_address": "4108 Hamilton Mill Rd, Buford, GA 30519, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019f14e2-0cd9-7016-90bb-1a127994142b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e2-0cd9-7016-90bb-1a127994142b",
        "storage_key": "property/6767906449167309/019f14e2-0cd9-7016-90bb-1a127994142b.webp",
        "width": 622,
        "height": 1280
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=1678&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=6127286221717052137&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-holland-point",
      "poi_latitude": "34.1032022",
      "poi_longitude": "-83.9755465",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 770-831-1054",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0284-739d-8fb5-a92f5f7f7d38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0284-739d-8fb5-a92f5f7f7d38",
        "storage_key": "property/6767906449167309/019d02f8-0284-739d-8fb5-a92f5f7f7d38.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6exyZR6T9YgR6RqX2lp-CFU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_84d89e1555638fabf49addac",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "QuikTrip",
      "poi_type": "Shopping & Retail",
      "poi_address": "2900 Buford Dr, Buford, GA 30519, USA",
      "poi_short_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_long_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f7-af08-7399-b694-3b440d0824f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02f7-af08-7399-b694-3b440d0824f8",
        "storage_key": "property/6767906449167309/019d02f7-af08-7399-b694-3b440d0824f8.webp",
        "width": 600,
        "height": 339
      },
      "poi_business_url": "https://locations.quiktrip.com/ga/buford/2900-buford-dr?utm_source=gmb&utm_medium=yext&y_source=1_MTYwMDQwNjgtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=159350921488421835&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "quiktrip",
      "poi_latitude": "34.0514465",
      "poi_longitude": "-83.99506170000001",
      "poi_miles_from_property": "9.8 mi",
      "poi_walking_minutes": "3 hours 37 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 770-831-1450",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0997-7262-81a0-748648d23341.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0997-7262-81a0-748648d23341",
        "storage_key": "property/6767906449167309/019d02f8-0997-7262-81a0-748648d23341.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJn_TiskqU9YgRy9PyndEgNgI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "ec_486b445f93c3c85df043f956",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Seckinger High School",
      "poi_type": "Education",
      "poi_address": "3655 Sardis Church Rd, Buford, GA 30519, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f7-b8d4-74b0-ad23-332158abd5fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02f7-b8d4-74b0-ad23-332158abd5fc",
        "storage_key": "property/6767906449167309/019d02f7-b8d4-74b0-ad23-332158abd5fc.webp",
        "width": 1280,
        "height": 1024
      },
      "poi_business_url": "http://gcpsk12.org/SeckingerHS",
      "poi_directions_map_url": "https://maps.google.com/?cid=12488420811477462624&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seckinger-high-school",
      "poi_latitude": "34.0794138",
      "poi_longitude": "-83.91174509999999",
      "poi_miles_from_property": "8.6 mi",
      "poi_walking_minutes": "3 hours 13 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 678-288-0800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-09ab-742c-bdcf-1147b83d788e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-09ab-742c-bdcf-1147b83d788e",
        "storage_key": "property/6767906449167309/019d02f8-09ab-742c-bdcf-1147b83d788e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJeUL9x7Tr9YgRYK61wY_IT60",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_c2250433b50100dc928034df",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Glenn C. Jones Middle School",
      "poi_type": "Education",
      "poi_address": "3575 Ridge Rd, Buford, GA 30519, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f7-b507-751c-bb8e-75f786781f82.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02f7-b507-751c-bb8e-75f786781f82",
        "storage_key": "property/6767906449167309/019d02f7-b507-751c-bb8e-75f786781f82.webp",
        "width": 1190,
        "height": 932
      },
      "poi_business_url": "https://www.gcpsk12.org/JonesMS",
      "poi_directions_map_url": "https://maps.google.com/?cid=17057397869151107846&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "glenn-c-jones-middle-school",
      "poi_latitude": "34.1035287",
      "poi_longitude": "-83.93764089999999",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 770-904-5450",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-09ab-742c-bdcf-1147b83d788e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-09ab-742c-bdcf-1147b83d788e",
        "storage_key": "property/6767906449167309/019d02f8-09ab-742c-bdcf-1147b83d788e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJS21GlFGT9YgRBrtB7_wMuOw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_e4d4cd86cfa48dac3d217d79",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Twin Rivers Middle School",
      "poi_type": "Education",
      "poi_address": "2300 Braselton Hwy, Buford, GA 30519, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019f14e2-05f1-766f-b881-0e8f5dbf956c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e2-05f1-766f-b881-0e8f5dbf956c",
        "storage_key": "property/6767906449167309/019f14e2-05f1-766f-b881-0e8f5dbf956c.webp",
        "width": 1239,
        "height": 1280
      },
      "poi_business_url": "https://twinriversms.gcpsk12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7711533322369422107&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "twin-rivers-middle-school",
      "poi_latitude": "34.0456132",
      "poi_longitude": "-83.94625880000001",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 678-407-7550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-09ab-742c-bdcf-1147b83d788e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-09ab-742c-bdcf-1147b83d788e",
        "storage_key": "property/6767906449167309/019d02f8-09ab-742c-bdcf-1147b83d788e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJY85-WyaV9YgRG9NqAbPeBGs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_1de7aa515ac35822f15cf4b1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Patrick Elementary School",
      "poi_type": "Education",
      "poi_address": "2707 Kilgore Rd, Buford, GA 30519, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019dabc5-dc25-763d-947d-8744046924bd.webp",
      "poi_featured_image_media": {
        "alt_text": "Building exterior with large windows and a street sign that reads Ackerman Way.",
        "public_id": "019dabc5-dc25-763d-947d-8744046924bd",
        "storage_key": "property/6767906449167309/019dabc5-dc25-763d-947d-8744046924bd.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://patrickes.gcpsk12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4311023593088862461&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "patrick-elementary-school",
      "poi_latitude": "34.0889173",
      "poi_longitude": "-83.9578939",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 678-765-5260",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-09ab-742c-bdcf-1147b83d788e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-09ab-742c-bdcf-1147b83d788e",
        "storage_key": "property/6767906449167309/019d02f8-09ab-742c-bdcf-1147b83d788e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGbpOpJ6U9YgR_chj_B3V0zs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_81d671f0740e1442d51422fc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Ivy Creek Elementary School",
      "poi_type": "Education",
      "poi_address": "3443 Ridge Rd, Buford, GA 30519, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019f14e2-29d5-7005-ba33-d255743568f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e2-29d5-7005-ba33-d255743568f0",
        "storage_key": "property/6767906449167309/019f14e2-29d5-7005-ba33-d255743568f0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://schools.gcpsk12.org/IvyCreekES",
      "poi_directions_map_url": "https://maps.google.com/?cid=1474654300408274904&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ivy-creek-elementary-school",
      "poi_latitude": "34.0970578",
      "poi_longitude": "-83.9365556",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 678-714-3655",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-09ab-742c-bdcf-1147b83d788e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-09ab-742c-bdcf-1147b83d788e",
        "storage_key": "property/6767906449167309/019d02f8-09ab-742c-bdcf-1147b83d788e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGTJdE1ST9YgR2F9W7kUGdxQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_d43cf89c6e075f2cb8fe3085",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "White Oak Elementary",
      "poi_type": "Education",
      "poi_address": "6442 Suwanee Dam Rd, Sugar Hill, GA 30518, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://whiteoakes.gcpsk12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16778200974418889550&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "white-oak-elementary",
      "poi_latitude": "34.146089",
      "poi_longitude": "-84.0663467",
      "poi_miles_from_property": "9.3 mi",
      "poi_walking_minutes": "3 hours 30 mins",
      "poi_biking_minutes": "1 hour 11 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 678-546-5550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-09ab-742c-bdcf-1147b83d788e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-09ab-742c-bdcf-1147b83d788e",
        "storage_key": "property/6767906449167309/019d02f8-09ab-742c-bdcf-1147b83d788e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJw8px51WQ9YgRTstZOuQk2Og",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_98a784300e5ca887a93a9a75",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Primrose School of Buford",
      "poi_type": "Education",
      "poi_address": "1650 Crossroads Dr, Buford, GA 30518, USA",
      "poi_short_description": "Accredited daycare providing infant care, preschool, and after-school programs.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f7-bb9d-72b9-b3a6-6868e51931c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02f7-bb9d-72b9-b3a6-6868e51931c8",
        "storage_key": "property/6767906449167309/019d02f7-bb9d-72b9-b3a6-6868e51931c8.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "https://www.primroseschools.com/schools/buford/?utm_source=gbp&utm_medium=maplistings",
      "poi_directions_map_url": "https://maps.google.com/?cid=4223410444198633821&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "primrose-school-of-buford",
      "poi_latitude": "34.0992962",
      "poi_longitude": "-84.01263569999999",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 770-932-5573",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-09ab-742c-bdcf-1147b83d788e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-09ab-742c-bdcf-1147b83d788e",
        "storage_key": "property/6767906449167309/019d02f8-09ab-742c-bdcf-1147b83d788e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJn5SMPf-T9YgRXWEiI2yRnDo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_9a029fa8ab3dd0ac8f12be16",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Big Blue Marble Academy Buford",
      "poi_type": "Education",
      "poi_address": "2715 Mall of Georgia Blvd, Buford, GA 30519, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f7-bae0-72db-8103-7cc6fb9eba58.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02f7-bae0-72db-8103-7cc6fb9eba58",
        "storage_key": "property/6767906449167309/019d02f7-bae0-72db-8103-7cc6fb9eba58.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://bbmacademy.com/location/buford/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15573675854477584780&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "big-blue-marble-academy-buford",
      "poi_latitude": "34.0651033",
      "poi_longitude": "-83.97365219999999",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 770-762-2521",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-09ab-742c-bdcf-1147b83d788e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-09ab-742c-bdcf-1147b83d788e",
        "storage_key": "property/6767906449167309/019d02f8-09ab-742c-bdcf-1147b83d788e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJlcJoNCKV9YgRjOk2Qa3PINg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_0d992b610bc875d7b426a8ed",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Georgia Gwinnett College",
      "poi_type": "Education",
      "poi_address": "1000 University Center Ln, Lawrenceville, GA 30043, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019dabba-316a-7197-9d0f-430fedd1fad1.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of a large brick building with a glass facade, set on a grassy field with trees and blue sky.",
        "public_id": "019dabba-316a-7197-9d0f-430fedd1fad1",
        "storage_key": "property/6767906449167309/019dabba-316a-7197-9d0f-430fedd1fad1.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.ggc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17256186828481170101&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "georgia-gwinnett-college",
      "poi_latitude": "33.9802966",
      "poi_longitude": "-84.0047709",
      "poi_miles_from_property": "11.3 mi",
      "poi_walking_minutes": "4 hours 12 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 678-407-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-09ab-742c-bdcf-1147b83d788e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-09ab-742c-bdcf-1147b83d788e",
        "storage_key": "property/6767906449167309/019d02f8-09ab-742c-bdcf-1147b83d788e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQyGfL2y-9YgRtQplSX5Keu8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_41af6b193b42dd5c9f2f6b59",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Sugar Hill Elementary School",
      "poi_type": "Education",
      "poi_address": "939 Level Creek Rd, Sugar Hill, GA 30518, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019f14e2-1954-762d-92e9-3ea7207f8174.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e2-1954-762d-92e9-3ea7207f8174",
        "storage_key": "property/6767906449167309/019f14e2-1954-762d-92e9-3ea7207f8174.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://schools.gcpsk12.org/SugarHillES",
      "poi_directions_map_url": "https://maps.google.com/?cid=15719585581278950851&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sugar-hill-elementary-school",
      "poi_latitude": "34.0996998",
      "poi_longitude": "-84.03998399999999",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 770-945-5735",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-09ab-742c-bdcf-1147b83d788e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-09ab-742c-bdcf-1147b83d788e",
        "storage_key": "property/6767906449167309/019d02f8-09ab-742c-bdcf-1147b83d788e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJT_1xS0iR9YgRw_V73MwvJ9o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_4519454becf242eca3b1b601",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Regal Mall Of Georgia",
      "poi_type": "Entertainment",
      "poi_address": "3333 Buford Dr Suite 3000, Buford, GA 30519, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f7-c177-708f-b790-2ab399420d20.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02f7-c177-708f-b790-2ab399420d20",
        "storage_key": "property/6767906449167309/019d02f7-c177-708f-b790-2ab399420d20.webp",
        "width": 400,
        "height": 266
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-mall-of-georgia-0701?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=4646288424599859034&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regal-mall-of-georgia",
      "poi_latitude": "34.06562",
      "poi_longitude": "-83.985016",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0a3c-753b-9581-f81f41722b19.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0a3c-753b-9581-f81f41722b19",
        "storage_key": "property/6767906449167309/019d02f8-0a3c-753b-9581-f81f41722b19.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJCZbP21qU9YgRWq9IgLTuekA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_7809472d1c250243363ecc2a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Paranoia Quest Escape the Room",
      "poi_type": "Entertainment",
      "poi_address": "3333 Buford Dr, Buford, GA 30519, USA",
      "poi_short_description": "Entertainment center at the Mall of Georgia featuring multiple escape rooms with different themes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019f14e2-1ba7-712d-8f64-107159e0fd3e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e2-1ba7-712d-8f64-107159e0fd3e",
        "storage_key": "property/6767906449167309/019f14e2-1ba7-712d-8f64-107159e0fd3e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.paranoiaquest.com/buford/?utm_source=google&utm_medium=gbp&utm_campaign=gbp_optimization",
      "poi_directions_map_url": "https://maps.google.com/?cid=6113194354888262035&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "paranoia-quest-escape-the-room",
      "poi_latitude": "34.0649705",
      "poi_longitude": "-83.98329620000001",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 678-310-8756",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0e64-729d-90e0-9e323dca554b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0e64-729d-90e0-9e323dca554b",
        "storage_key": "property/6767906449167309/019d02f8-0e64-729d-90e0-9e323dca554b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeYxJLFuU9YgRk8EJbuBt1lQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_77e50979118678412b850a32",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Gwinnett Environmental and Heritage Center",
      "poi_type": "Entertainment",
      "poi_address": "Gwinnett Environmental & Heritage Center, 2020 Clean Water Dr, Buford, GA 30519, USA",
      "poi_short_description": "Museum for educational exhibits on environmental topics, plus paved trails.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019f14e2-3582-752b-8ba1-983b0698e605.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e2-3582-752b-8ba1-983b0698e605",
        "storage_key": "property/6767906449167309/019f14e2-3582-752b-8ba1-983b0698e605.webp",
        "width": 1280,
        "height": 832
      },
      "poi_business_url": "https://www.gwinnettcounty.com/government/departments/parks-recreation/parks/gwinnett-environmental-heritage-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=1854322276253968960&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gwinnett-environmental-and-heritage-center",
      "poi_latitude": "34.0639734",
      "poi_longitude": "-84.00459330000001",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 770-904-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0e64-729d-90e0-9e323dca554b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0e64-729d-90e0-9e323dca554b",
        "storage_key": "property/6767906449167309/019d02f8-0e64-729d-90e0-9e323dca554b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWcobgmXs9YgRQCo2H0nguxk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_adff14981a25b02956357199",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Andretti Indoor Karting & Games Buford",
      "poi_type": "Entertainment",
      "poi_address": "2925 Buford Dr Ste 300, Buford, GA 30519, USA",
      "poi_short_description": "Electric go-kart races on a multi-level track in a spacious indoor facility also featuring an arcade, laser tag, simulator rides and a 7D Xperience motion theater.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019f14e2-1a79-7408-b377-e2e8d236727b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e2-1a79-7408-b377-e2e8d236727b",
        "storage_key": "property/6767906449167309/019f14e2-1a79-7408-b377-e2e8d236727b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://andrettikarting.com/buford/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11010336203036559450&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "andretti-indoor-karting--games-buford",
      "poi_latitude": "34.0546177",
      "poi_longitude": "-83.9912519",
      "poi_miles_from_property": "10.1 mi",
      "poi_walking_minutes": "3 hours 43 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 470-646-3278",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0e64-729d-90e0-9e323dca554b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0e64-729d-90e0-9e323dca554b",
        "storage_key": "property/6767906449167309/019d02f8-0e64-729d-90e0-9e323dca554b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9T5UC5KV9YgRWgie_3CSzJg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_2aff0355626ac6491e74797f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Topgolf Buford",
      "poi_type": "Entertainment",
      "poi_address": "2935 Buford Dr, Buford, GA 30519, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019dabba-27e1-70cb-9225-418d99b9e658.webp",
      "poi_featured_image_media": {
        "alt_text": "Bar with stools and televisions showing sports.",
        "public_id": "019dabba-27e1-70cb-9225-418d99b9e658",
        "storage_key": "property/6767906449167309/019dabba-27e1-70cb-9225-418d99b9e658.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://topgolf.com/us/buford/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15704193310792067326&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "topgolf-buford",
      "poi_latitude": "34.0554045",
      "poi_longitude": "-83.9892837",
      "poi_miles_from_property": "10.2 mi",
      "poi_walking_minutes": "3 hours 46 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 470-822-1711",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0277-744b-aec6-9662b5f4ee22.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0277-744b-aec6-9662b5f4ee22",
        "storage_key": "property/6767906449167309/019d02f8-0277-744b-aec6-9662b5f4ee22.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBzhS0mCV9YgR_qjTnZyA8Nk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_acdeca891621568bb8bd3b07",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Gwinnett Stripers",
      "poi_type": "Entertainment",
      "poi_address": "2500 Buford Dr, Lawrenceville, GA 30043, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019dabba-44c8-74a0-a996-7c69d9314928.webp",
      "poi_featured_image_media": {
        "alt_text": "Baseball stadium with apartment buildings in the background.",
        "public_id": "019dabba-44c8-74a0-a996-7c69d9314928",
        "storage_key": "property/6767906449167309/019dabba-44c8-74a0-a996-7c69d9314928.webp",
        "width": 3072,
        "height": 2182
      },
      "poi_business_url": "https://www.milb.com/gwinnett",
      "poi_directions_map_url": "https://maps.google.com/?cid=12143037442933802848&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gwinnett-stripers",
      "poi_latitude": "34.0413875",
      "poi_longitude": "-83.9926059",
      "poi_miles_from_property": "9.6 mi",
      "poi_walking_minutes": "3 hours 32 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 678-277-0340",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0e64-729d-90e0-9e323dca554b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0e64-729d-90e0-9e323dca554b",
        "storage_key": "property/6767906449167309/019d02f8-0e64-729d-90e0-9e323dca554b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdaNbc7eV9YgRYEdWwDe8hKg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_club"
    },
    {
      "id": "ec_c3dca4408cf7c21e6a8844da",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Gas South Arena",
      "poi_type": "Entertainment",
      "poi_address": "6400 Sugarloaf Pkwy, Duluth, GA 30097, USA",
      "poi_short_description": "13,000-seat arena hosting concerts, sporting events, ballet, rodeos, conventions & trade shows.",
      "poi_long_description": "13,000-seat arena hosting concerts, sporting events, ballet, rodeos, conventions & trade shows.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019f14e2-3206-76cb-b5b8-ec5f8d6eab9d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e2-3206-76cb-b5b8-ec5f8d6eab9d",
        "storage_key": "property/6767906449167309/019f14e2-3206-76cb-b5b8-ec5f8d6eab9d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.gassouthdistrict.com/venues/detail/arena",
      "poi_directions_map_url": "https://maps.google.com/?cid=13265462882721543272&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gas-south-arena",
      "poi_latitude": "33.9916564",
      "poi_longitude": "-84.0939102",
      "poi_miles_from_property": "9.9 mi",
      "poi_walking_minutes": "3 hours 41 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 770-813-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0e64-729d-90e0-9e323dca554b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0e64-729d-90e0-9e323dca554b",
        "storage_key": "property/6767906449167309/019d02f8-0e64-729d-90e0-9e323dca554b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs-HAukm99YgRaDS_WTVkGLg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "ec_eeedf1b6f691b4c3a0c829ef",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Margaritaville at Lanier Islands",
      "poi_type": "Entertainment",
      "poi_address": "7650 Lanier Islands Pkwy, Buford, GA 30518, USA",
      "poi_short_description": "Lakeside water park with slides & a large wave pool, plus a mini-golf course & arcades.",
      "poi_long_description": "Lakeside water park with slides & a large wave pool, plus a mini-golf course & arcades.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019dabc5-e5c1-735e-a282-760fc0afe3e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dabc5-e5c1-735e-a282-760fc0afe3e6",
        "storage_key": "property/6767906449167309/019dabc5-e5c1-735e-a282-760fc0afe3e6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.margaritavilleresorts.com/margaritaville-at-lanier-islands?utm_source=google&utm_medium=listing&utm_campaign=margaritaville+at+lanier+islands",
      "poi_directions_map_url": "https://maps.google.com/?cid=5866617011480313763&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "margaritaville-at-lanier-islands",
      "poi_latitude": "34.177897",
      "poi_longitude": "-84.0295009",
      "poi_miles_from_property": "12.0 mi",
      "poi_walking_minutes": "4 hours 27 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 470-323-3440",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0e64-729d-90e0-9e323dca554b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0e64-729d-90e0-9e323dca554b",
        "storage_key": "property/6767906449167309/019d02f8-0e64-729d-90e0-9e323dca554b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV-B9ZPmR9YgRoz-M2hZpalE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_f4ae58217a4e8f5ea1a3d7ba",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "The Twisted Oar",
      "poi_type": "Entertainment",
      "poi_address": "6900 Lanier Islands Pkwy, Buford, GA 30518, USA",
      "poi_short_description": "Mellow lakeside eatery & watering hole offering pub grub, draft beer, TVs, a patio & live music.",
      "poi_long_description": "Mellow lakeside eatery & watering hole offering pub grub, draft beer, TVs, a patio & live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019f14e2-39ce-77bb-aa73-543b0d7ff2f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e2-39ce-77bb-aa73-543b0d7ff2f2",
        "storage_key": "property/6767906449167309/019f14e2-39ce-77bb-aa73-543b0d7ff2f2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.thetwistedoar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3167213410506632735&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-twisted-oar",
      "poi_latitude": "34.1725558",
      "poi_longitude": "-84.0029522",
      "poi_miles_from_property": "10.3 mi",
      "poi_walking_minutes": "3 hours 49 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 678-714-7572",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0277-744b-aec6-9662b5f4ee22.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0277-744b-aec6-9662b5f4ee22",
        "storage_key": "property/6767906449167309/019d02f8-0277-744b-aec6-9662b5f4ee22.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJA0y5yBGS9YgRH-4Z9dAz9Cs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_162961af939079ca585d2d90",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "37 Main Restaurant + Bar",
      "poi_type": "Entertainment",
      "poi_address": "37 E Main St NE, Buford, GA 30518, USA",
      "poi_short_description": "Live local rock bands & touring acts, accompanied by classic American food with a Southern flair.",
      "poi_long_description": "Live local rock bands & touring acts, accompanied by classic American food with a Southern flair.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f7-a328-70eb-a1a2-96a0864f6524.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02f7-a328-70eb-a1a2-96a0864f6524",
        "storage_key": "property/6767906449167309/019d02f7-a328-70eb-a1a2-96a0864f6524.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.37main.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12622678145107244913&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "37-main-restaurant--bar",
      "poi_latitude": "34.1202016",
      "poi_longitude": "-84.005392",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 678-288-2030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019f14e2-c2e4-73b5-84e4-f413bbce0d1e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-c2e4-73b5-84e4-f413bbce0d1e",
        "storage_key": "property/6767906449167309/019f14e2-c2e4-73b5-84e4-f413bbce0d1e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx26YxcKT9YgRcTc0KeXCLK8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "ec_8839272a043e8361426f9e04",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Northeast Georgia Medical Center Braselton",
      "poi_type": "Health and Wellness",
      "poi_address": "1400 River Pl, Braselton, GA 30517, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019f14e2-4403-7235-b38e-0d8e29767619.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e2-4403-7235-b38e-0d8e29767619",
        "storage_key": "property/6767906449167309/019f14e2-4403-7235-b38e-0d8e29767619.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.nghs.com/locations/braselton",
      "poi_directions_map_url": "https://maps.google.com/?cid=15998172264196890034&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northeast-georgia-medical-center-braselton",
      "poi_latitude": "34.1204089",
      "poi_longitude": "-83.837731",
      "poi_miles_from_property": "12.3 mi",
      "poi_walking_minutes": "4 hours 33 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 770-848-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0e64-729d-90e0-9e323dca554b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0e64-729d-90e0-9e323dca554b",
        "storage_key": "property/6767906449167309/019d02f8-0e64-729d-90e0-9e323dca554b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNbCdyZru9YgRsl32junsBN4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_fa18800d7ea6bd1b91d2c1f1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Northeast Georgia Physicians Group Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "4445 S Lee St Ste 105, Buford, GA 30518, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019dabc5-fb62-729f-86c8-29563157bdc2.webp",
      "poi_featured_image_media": {
        "alt_text": "Modern building exterior with \"URGENT CARE\" signage and large glass windows.",
        "public_id": "019dabc5-fb62-729f-86c8-29563157bdc2",
        "storage_key": "property/6767906449167309/019dabc5-fb62-729f-86c8-29563157bdc2.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ngpg.org/urgent-care/buford",
      "poi_directions_map_url": "https://maps.google.com/?cid=1946798232445572899&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northeast-georgia-physicians-group-urgent-care",
      "poi_latitude": "34.1045342",
      "poi_longitude": "-84.0018353",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 770-848-9240",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0e64-729d-90e0-9e323dca554b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0e64-729d-90e0-9e323dca554b",
        "storage_key": "property/6767906449167309/019d02f8-0e64-729d-90e0-9e323dca554b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ00TLvKeT9YgRI9dGhq1qBBs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_7cb51670922b89e675cb90d3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Peachtree Immediate Care - Buford",
      "poi_type": "Health and Wellness",
      "poi_address": "3425 Buford Dr Ste 200, Buford, GA 30519, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019f14e2-39db-757b-801e-df07e7baeef9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e2-39db-757b-801e-df07e7baeef9",
        "storage_key": "property/6767906449167309/019f14e2-39db-757b-801e-df07e7baeef9.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "https://www.peachtreemed.com/location/buford",
      "poi_directions_map_url": "https://maps.google.com/?cid=12740398420487796952&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "peachtree-immediate-care---buford",
      "poi_latitude": "34.0754864",
      "poi_longitude": "-83.98319819999999",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 678-546-0200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0e64-729d-90e0-9e323dca554b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0e64-729d-90e0-9e323dca554b",
        "storage_key": "property/6767906449167309/019d02f8-0e64-729d-90e0-9e323dca554b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ26byWeU9YgR2Hgfptz8zrA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_83b974ede4c094cacfddf166",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "MedLife Primary & Urgent Care Buford",
      "poi_type": "Health and Wellness",
      "poi_address": "2129 Friendship Rd, Buford, GA 30519, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019f14e2-44c4-75dd-9974-6b67fbb4e95f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e2-44c4-75dd-9974-6b67fbb4e95f",
        "storage_key": "property/6767906449167309/019f14e2-44c4-75dd-9974-6b67fbb4e95f.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "http://www.medlifeclinics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12474829106384622443&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "medlife-primary--urgent-care-buford",
      "poi_latitude": "34.1096263",
      "poi_longitude": "-83.8774844",
      "poi_miles_from_property": "9.7 mi",
      "poi_walking_minutes": "3 hours 36 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 770-209-2787",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0e64-729d-90e0-9e323dca554b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0e64-729d-90e0-9e323dca554b",
        "storage_key": "property/6767906449167309/019d02f8-0e64-729d-90e0-9e323dca554b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVUqnzg_t9YgRa1PCT_p-H60",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_b735f4a56cb10c56b80bc0a8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "3205 Woodward Crossing Blvd Ste B, Buford, GA 30519, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019f14e1-f7dd-750f-a688-a0b1d81711c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e1-f7dd-750f-a688-a0b1d81711c8",
        "storage_key": "property/6767906449167309/019f14e1-f7dd-750f-a688-a0b1d81711c8.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.cvs.com/store-locator/buford-ga-pharmacies/3205-woodward-crossing-blvd-ste-b-buford-ga-30519/storeid=16561?WT.mc_id=LS_GOOGLE_RX_16561",
      "poi_directions_map_url": "https://maps.google.com/?cid=11595622792104411839&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "34.0704122",
      "poi_longitude": "-83.9817372",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 678-482-6528",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0997-7262-81a0-7886b7d2727f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0997-7262-81a0-7886b7d2727f",
        "storage_key": "property/6767906449167309/019d02f8-0997-7262-81a0-7886b7d2727f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeye_R1yU9YgRv4LOQH7t66A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_2c99584b21050e4dec6b17e7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Costco Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1550 Mall of Georgia Blvd NE, Buford, GA 30519, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f7-d551-72a9-8433-247a38926d50.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02f7-d551-72a9-8433-247a38926d50",
        "storage_key": "property/6767906449167309/019d02f7-d551-72a9-8433-247a38926d50.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.costco.com/warehouse-locations/buford-GA-366.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=4482595369115960022&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "costco-pharmacy",
      "poi_latitude": "34.06271419999999",
      "poi_longitude": "-83.99665790000002",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 678-288-3020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0997-7262-81a0-7886b7d2727f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0997-7262-81a0-7886b7d2727f",
        "storage_key": "property/6767906449167309/019d02f8-0997-7262-81a0-7886b7d2727f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSWtU8TeU9YgR1sL3B71gNT4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_c7f1610d88835d5c917826c5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Kroger Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "3300 Hamilton Mill Rd, Buford, GA 30519, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019f14e2-444a-71ff-a6b8-c35657ecd845.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e2-444a-71ff-a6b8-c35657ecd845",
        "storage_key": "property/6767906449167309/019f14e2-444a-71ff-a6b8-c35657ecd845.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/rx/pharmacy/details/011/00494?cid=loc_01100494P_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=4762557010974773579&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger-pharmacy",
      "poi_latitude": "34.0931906",
      "poi_longitude": "-83.9375448",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 770-614-1086",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0997-7262-81a0-7886b7d2727f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0997-7262-81a0-7886b7d2727f",
        "storage_key": "property/6767906449167309/019d02f8-0997-7262-81a0-7886b7d2727f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNyOLDlaT9YgRS5GyTV4AGEI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_74d2ca338fe16195f3c5bea1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "4125 Buford Dr, Buford, GA 30518, USA",
      "poi_short_description": "Gym chain featuring a variety of equipment and tanning beds, plus massage chairs.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f7-d7df-70f9-b86f-3111a6cf758c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02f7-d7df-70f9-b86f-3111a6cf758c",
        "storage_key": "property/6767906449167309/019d02f7-d7df-70f9-b86f-3111a6cf758c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/buford-ga?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=3043924009964538659&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "34.0939527",
      "poi_longitude": "-84.00177289999999",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 470-589-1181",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0e64-729d-90e0-9e323dca554b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0e64-729d-90e0-9e323dca554b",
        "storage_key": "property/6767906449167309/019d02f8-0e64-729d-90e0-9e323dca554b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbdssrAmU9YgRIws4ecIwPio",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_b7bb61248edd6911f2f1f191",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "5019 W Broad St NE Suite 107/109, Sugar Hill, GA 30518, USA",
      "poi_short_description": "Clean gym offering group fitness sessions using real-time heart-rate training to improve athletic performance.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019f14e2-5b02-722f-adf9-9cb48a62a762.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e2-5b02-722f-adf9-9cb48a62a762",
        "storage_key": "property/6767906449167309/019f14e2-5b02-722f-adf9-9cb48a62a762.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/sugar-hill-georgia-0845?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=5387040723821098803&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "34.1068055",
      "poi_longitude": "-84.0347244",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 678-786-4120",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0e64-729d-90e0-9e323dca554b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0e64-729d-90e0-9e323dca554b",
        "storage_key": "property/6767906449167309/019d02f8-0e64-729d-90e0-9e323dca554b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnb0Pf8GQ9YgRM3frHf-cwko",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_ddcda087ee86583e5d511e3b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Massage Envy",
      "poi_type": "Health and Wellness",
      "poi_address": "3420 Buford Dr Ste E-770, Buford, GA 30519, USA",
      "poi_short_description": "Part of a chain, this spa offers massage, facials, and skin care treatments, plus total body stretch services.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019f14e2-4848-751b-a931-95d0ba84995d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e2-4848-751b-a931-95d0ba84995d",
        "storage_key": "property/6767906449167309/019f14e2-4848-751b-a931-95d0ba84995d.webp",
        "width": 1000,
        "height": 665
      },
      "poi_business_url": "https://locations.massageenvy.com/georgia/buford/3420-buford-drive.html?utm_source=GMB&utm_medium=useractions&utm_campaign=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=13377820230181554444&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "massage-envy",
      "poi_latitude": "34.0755542",
      "poi_longitude": "-83.986531",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 678-541-6868",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0e64-729d-90e0-9e323dca554b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0e64-729d-90e0-9e323dca554b",
        "storage_key": "property/6767906449167309/019d02f8-0e64-729d-90e0-9e323dca554b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr6a41meU9YgRDIkB4Z6Qp7k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "massage_spa"
    },
    {
      "id": "ec_e264943e78d2c77ba2f38389",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Gwinnett Environmental and Heritage Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Gwinnett Environmental & Heritage Center, 2020 Clean Water Dr, Buford, GA 30519, USA",
      "poi_short_description": "Museum for educational exhibits on environmental topics, plus paved trails.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019f14e2-3582-752b-8ba1-983b0698e605.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e2-3582-752b-8ba1-983b0698e605",
        "storage_key": "property/6767906449167309/019f14e2-3582-752b-8ba1-983b0698e605.webp",
        "width": 1280,
        "height": 832
      },
      "poi_business_url": "https://www.gwinnettcounty.com/government/departments/parks-recreation/parks/gwinnett-environmental-heritage-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=1854322276253968960&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gwinnett-environmental-and-heritage-center",
      "poi_latitude": "34.0639734",
      "poi_longitude": "-84.00459330000001",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 770-904-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0e64-729d-90e0-9e323dca554b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0e64-729d-90e0-9e323dca554b",
        "storage_key": "property/6767906449167309/019d02f8-0e64-729d-90e0-9e323dca554b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWcobgmXs9YgRQCo2H0nguxk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_0fa62c460bbf8c608b2adde2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Mill Creek Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2355 Mall of Georgia Blvd, Buford, GA 30519, USA",
      "poi_short_description": "Walking trails around the Ivy Creek Rivers at this lush nature preserve.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019dabc6-1697-727f-982e-5be00ab03b33.webp",
      "poi_featured_image_media": {
        "alt_text": "Wooden boardwalk through a lush green marsh with trees.",
        "public_id": "019dabc6-1697-727f-982e-5be00ab03b33",
        "storage_key": "property/6767906449167309/019dabc6-1697-727f-982e-5be00ab03b33.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://gwf.org/millcreek/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3664859578356506963&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mill-creek-nature-center",
      "poi_latitude": "34.0615073",
      "poi_longitude": "-83.9832562",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 770-787-7887",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0e79-763a-ab71-d22b98eddd11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0e79-763a-ab71-d22b98eddd11",
        "storage_key": "property/6767906449167309/019d02f8-0e79-763a-ab71-d22b98eddd11.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5TQRdFCU9YgRU6Ggh14y3DI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "ec_27632a0ddc875a9e6dbd6043",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Ivy Creek Greenway Mall of Georgia Access Point",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Mall of Georgia Blvd, Buford, GA 30519, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f7-cb43-70b8-8eb1-5272d6c3dbd4.webp",
      "poi_featured_image_media": {
        "alt_text": "Wooded walking trail with gravel path and wooden bridge in the foreground.",
        "public_id": "019d02f7-cb43-70b8-8eb1-5272d6c3dbd4",
        "storage_key": "property/6767906449167309/019d02f7-cb43-70b8-8eb1-5272d6c3dbd4.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=239441537883305394&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ivy-creek-greenway-mall-of-georgia-access-point",
      "poi_latitude": "34.0619016",
      "poi_longitude": "-83.98286879999999",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 770-787-7887",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0e79-763a-ab71-d22b98eddd11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0e79-763a-ab71-d22b98eddd11",
        "storage_key": "property/6767906449167309/019d02f8-0e79-763a-ab71-d22b98eddd11.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ79cDhjmV9YgRsvUBYs-qUgM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_7fc71bbc7a60b52df6abeabc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Bogan Park Community Recreation and Aquatic Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2723 N Bogan Rd NE, Buford, GA 30519, USA",
      "poi_short_description": "Large complex offering multiple swimming pools, a sizable gym, a dance studio & more.",
      "poi_long_description": "Large complex offering multiple swimming pools, a sizable gym, a dance studio & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019f14e0-24a0-72b9-898b-e16e55eb2bea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e0-24a0-72b9-898b-e16e55eb2bea",
        "storage_key": "property/6767906449167309/019f14e0-24a0-72b9-898b-e16e55eb2bea.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.gwinnettcounty.com/government/departments/parks-recreation/parks/bogan",
      "poi_directions_map_url": "https://maps.google.com/?cid=6515648682191093188&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bogan-park-community-recreation-and-aquatic-center",
      "poi_latitude": "34.1069405",
      "poi_longitude": "-83.96872119999999",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 678-277-0850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0e79-763a-ab71-d22b98eddd11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0e79-763a-ab71-d22b98eddd11",
        "storage_key": "property/6767906449167309/019d02f8-0e79-763a-ab71-d22b98eddd11.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJHUMUenqT9YgRxP09f_Q7bFo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_e52e3c9c79fd86d417b5d4e3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Buford City Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2700 Sawnee Ave, Buford, GA 30518, USA",
      "poi_short_description": "Sports park offering baseball, tennis, and a playground, plus a public restroom.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019dabc6-34be-729c-80d5-f98421769b4f.webp",
      "poi_featured_image_media": {
        "alt_text": "Playground with slides and covered seating.",
        "public_id": "019dabc6-34be-729c-80d5-f98421769b4f",
        "storage_key": "property/6767906449167309/019dabc6-34be-729c-80d5-f98421769b4f.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.cityofbuford.com/park.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=4110165205436526294&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "buford-city-park",
      "poi_latitude": "34.132876",
      "poi_longitude": "-83.9891217",
      "poi_miles_from_property": "6.9 mi",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0e79-763a-ab71-d22b98eddd11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0e79-763a-ab71-d22b98eddd11",
        "storage_key": "property/6767906449167309/019d02f8-0e79-763a-ab71-d22b98eddd11.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJLw7VlbOT9YgR1u42Tno9Cjk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_d013e80d6cf870cf56a287e7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Buford Dam Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1200 Buford Dam Rd, Buford, GA 30518, USA",
      "poi_short_description": "Serene lakeside park with a sandy, swimming beach, plus picnic areas & recreational facilities.",
      "poi_long_description": "Serene lakeside park with a sandy, swimming beach, plus picnic areas & recreational facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f7-e8af-726b-8d60-964a08d70989.webp",
      "poi_featured_image_media": {
        "alt_text": "River flowing through a rocky gorge with grassy hillsides and a dam in the distance.",
        "public_id": "019d02f7-e8af-726b-8d60-964a08d70989",
        "storage_key": "property/6767906449167309/019d02f7-e8af-726b-8d60-964a08d70989.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14956536085886176249&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "buford-dam-park",
      "poi_latitude": "34.152687",
      "poi_longitude": "-84.06268430000002",
      "poi_miles_from_property": "10.2 mi",
      "poi_walking_minutes": "3 hours 51 mins",
      "poi_biking_minutes": "1 hour 17 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 770-945-9531",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0e79-763a-ab71-d22b98eddd11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0e79-763a-ab71-d22b98eddd11",
        "storage_key": "property/6767906449167309/019d02f8-0e79-763a-ab71-d22b98eddd11.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJQViyXFKQ9YgR-YuOtVNKkM8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_750e65271e0c4bca75bf71c8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Margaritaville at Lanier Islands",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7650 Lanier Islands Pkwy, Buford, GA 30518, USA",
      "poi_short_description": "Lakeside water park with slides & a large wave pool, plus a mini-golf course & arcades.",
      "poi_long_description": "Lakeside water park with slides & a large wave pool, plus a mini-golf course & arcades.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019dabc5-e5c1-735e-a282-760fc0afe3e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dabc5-e5c1-735e-a282-760fc0afe3e6",
        "storage_key": "property/6767906449167309/019dabc5-e5c1-735e-a282-760fc0afe3e6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.margaritavilleresorts.com/margaritaville-at-lanier-islands?utm_source=google&utm_medium=listing&utm_campaign=margaritaville+at+lanier+islands",
      "poi_directions_map_url": "https://maps.google.com/?cid=5866617011480313763&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "margaritaville-at-lanier-islands",
      "poi_latitude": "34.177897",
      "poi_longitude": "-84.0295009",
      "poi_miles_from_property": "12.0 mi",
      "poi_walking_minutes": "4 hours 27 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 470-323-3440",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0e64-729d-90e0-9e323dca554b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0e64-729d-90e0-9e323dca554b",
        "storage_key": "property/6767906449167309/019d02f8-0e64-729d-90e0-9e323dca554b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV-B9ZPmR9YgRoz-M2hZpalE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_585a36f0c259e27220a05514",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "George Pierce Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "55 Buford Hwy NE, Suwanee, GA 30024, USA",
      "poi_short_description": "Boasting a recreation center, this 304-acre park also offers areas for sports, plus a playground.",
      "poi_long_description": "Boasting a recreation center, this 304-acre park also offers areas for sports, plus a playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019dabba-cb55-7166-9a77-0f96b43f7710.webp",
      "poi_featured_image_media": {
        "alt_text": "George Pierce Park sign with event information.",
        "public_id": "019dabba-cb55-7166-9a77-0f96b43f7710",
        "storage_key": "property/6767906449167309/019dabba-cb55-7166-9a77-0f96b43f7710.webp",
        "width": 3000,
        "height": 1950
      },
      "poi_business_url": "https://www.gwinnettcounty.com/government/departments/parks-recreation/parks/george-pierce",
      "poi_directions_map_url": "https://maps.google.com/?cid=2493886098274336&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "george-pierce-park",
      "poi_latitude": "34.060612",
      "poi_longitude": "-84.0462057",
      "poi_miles_from_property": "6.4 mi",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 678-277-0910",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0e79-763a-ab71-d22b98eddd11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0e79-763a-ab71-d22b98eddd11",
        "storage_key": "property/6767906449167309/019d02f8-0e79-763a-ab71-d22b98eddd11.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJu-wynfmW9YgRIHj_Gi3cCAA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_0df7e6c977dfdaa596228f2f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Suwanee Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1170 Buford Hwy, Suwanee, GA 30024, USA",
      "poi_short_description": "This 85-acre wooded park known for its 18-hole disc golf course & trails also has picnic pavilions.",
      "poi_long_description": "This 85-acre wooded park known for its 18-hole disc golf course & trails also has picnic pavilions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019dabc6-2311-74c5-a98c-6b68fd10f3fd.webp",
      "poi_featured_image_media": {
        "alt_text": "Map of Suwanee Creek Park Orienteering Course with trails and points.",
        "public_id": "019dabc6-2311-74c5-a98c-6b68fd10f3fd",
        "storage_key": "property/6767906449167309/019dabc6-2311-74c5-a98c-6b68fd10f3fd.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.suwanee.com/services/parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=3765587647105414549&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "suwanee-creek-park",
      "poi_latitude": "34.0365042",
      "poi_longitude": "-84.0851964",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 770-945-8996",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0e79-763a-ab71-d22b98eddd11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0e79-763a-ab71-d22b98eddd11",
        "storage_key": "property/6767906449167309/019d02f8-0e79-763a-ab71-d22b98eddd11.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ22YQzJSX9YgRlTVRnAMOQjQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_27f9bb61b5a1143d460f32ac",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Little Mulberry Park, Auburn Entrance",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3855 Fence Rd NE, Dacula, GA 30019, USA",
      "poi_short_description": "Park featuring playgrounds for different age groups, plus miles of paved and woodland trails.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019f14e2-6724-74dd-8caf-aac9beffeb1e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e2-6724-74dd-8caf-aac9beffeb1e",
        "storage_key": "property/6767906449167309/019f14e2-6724-74dd-8caf-aac9beffeb1e.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.gwinnettcounty.com/government/departments/parks-recreation/parks/little-mulberry",
      "poi_directions_map_url": "https://maps.google.com/?cid=10492831894967179685&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "little-mulberry-park-auburn-entrance",
      "poi_latitude": "34.0371368",
      "poi_longitude": "-83.87727249999999",
      "poi_miles_from_property": "8.9 mi",
      "poi_walking_minutes": "3 hours 19 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 678-277-0850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0e79-763a-ab71-d22b98eddd11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0e79-763a-ab71-d22b98eddd11",
        "storage_key": "property/6767906449167309/019d02f8-0e79-763a-ab71-d22b98eddd11.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ74QWTU7q9YgRpVlo2wMHnpE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_eef28ac62640ded2580906f1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "1355 Mall of Georgia Boulevard Car Park",
      "poi_type": "Transportation & Transit",
      "poi_address": "1355 Mall of Georgia Blvd, Buford, GA 30519, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14199287954396934094&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "1355-mall-of-georgia-boulevard-car-park",
      "poi_latitude": "34.0583548",
      "poi_longitude": "-83.9970259",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-130a-74a9-8972-150a1517e9c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-130a-74a9-8972-150a1517e9c6",
        "storage_key": "property/6767906449167309/019d02f8-130a-74a9-8972-150a1517e9c6.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJp-_eRjaU9YgRzu9P2SkBDsU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "ec_a42e5f8b2b468ac981be9395",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Buford Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Buford Dr, Buford, GA 30519, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019f14e2-6e2c-730b-b920-74fb9e87605e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e2-6e2c-730b-b920-74fb9e87605e",
        "storage_key": "property/6767906449167309/019f14e2-6e2c-730b-b920-74fb9e87605e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14072662134422036930&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "buford-park-and-ride",
      "poi_latitude": "34.0851254",
      "poi_longitude": "-83.9957532",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-130a-74a9-8972-150a1517e9c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-130a-74a9-8972-150a1517e9c6",
        "storage_key": "property/6767906449167309/019d02f8-130a-74a9-8972-150a1517e9c6.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQAAUw2U9YgRwuFQrqYjTMM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_016004cf595e84419e466f01",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Premier Storage at Hamilton Mill",
      "poi_type": "Transportation & Transit",
      "poi_address": "3220 Sardis Church Rd, Buford, GA 30519, USA",
      "poi_short_description": "Clean storage unit rentals facility offering clean units, packing supplies and RV parking.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019f14e2-659b-758e-91e6-cbc381443f28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e2-659b-758e-91e6-cbc381443f28",
        "storage_key": "property/6767906449167309/019f14e2-659b-758e-91e6-cbc381443f28.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.absolutemgmt.com/storage-locations/ga/buford/3220-sardis-church-rd/?utm_source=GoogleMyBusiness&utm_medium=organic&utm_campaign=1347-Premier_Storage_at_Hamilton_Mill",
      "poi_directions_map_url": "https://maps.google.com/?cid=12204284672044154050&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "premier-storage-at-hamilton-mill",
      "poi_latitude": "34.0771508",
      "poi_longitude": "-83.9225173",
      "poi_miles_from_property": "9.3 mi",
      "poi_walking_minutes": "3 hours 30 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 470-458-9588",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0e64-729d-90e0-9e323dca554b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0e64-729d-90e0-9e323dca554b",
        "storage_key": "property/6767906449167309/019d02f8-0e64-729d-90e0-9e323dca554b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ95itD0Xr9YgRwrzvhj9UXqk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "storage"
    },
    {
      "id": "ec_1e0dc1a07ccd6b1a1b35f895",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Sugarloaf Mills Park/Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "1905 N Brown Rd, Lawrenceville, GA 30043, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019dabc6-54c9-7645-b303-e7983d43a933.webp",
      "poi_featured_image_media": {
        "alt_text": "Gwinnett County Transit bus with a stop sign and route number 40 displayed.",
        "public_id": "019dabc6-54c9-7645-b303-e7983d43a933",
        "storage_key": "property/6767906449167309/019dabc6-54c9-7645-b303-e7983d43a933.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.gwinnettcounty.com/portal/gwinnett/Departments/Transportation/GwinnettCountyTransit",
      "poi_directions_map_url": "https://maps.google.com/?cid=16218795295653938135&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sugarloaf-mills-parkride",
      "poi_latitude": "33.9834908",
      "poi_longitude": "-84.08409499999999",
      "poi_miles_from_property": "9.8 mi",
      "poi_walking_minutes": "3 hours 38 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 770-822-5010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-130a-74a9-8972-150a1517e9c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-130a-74a9-8972-150a1517e9c6",
        "storage_key": "property/6767906449167309/019d02f8-130a-74a9-8972-150a1517e9c6.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJY5Ms6j699YgR18M6-mO8FOE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_59a3e647f6b20a18417d86fd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Gwinnett County Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "3486 Satellite Blvd NW #3478, Duluth, GA 30096, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019f14e2-7084-752b-ace2-d703122e3ae2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e2-7084-752b-ace2-d703122e3ae2",
        "storage_key": "property/6767906449167309/019f14e2-7084-752b-ace2-d703122e3ae2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.gctransit.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3216275387600768926&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gwinnett-county-transit-center",
      "poi_latitude": "33.9631555",
      "poi_longitude": "-84.1312757",
      "poi_miles_from_property": "13.9 mi",
      "poi_walking_minutes": "5 hours 8 mins",
      "poi_biking_minutes": "1 hour 19 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 770-822-5010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0e64-729d-90e0-9e323dca554b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0e64-729d-90e0-9e323dca554b",
        "storage_key": "property/6767906449167309/019d02f8-0e64-729d-90e0-9e323dca554b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnen6Yxuj9YgRno_GqWyBoiw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_31bddcfd2d4f7b2549bc27e3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Doraville",
      "poi_type": "Transportation & Transit",
      "poi_address": "6000 New Peachtree Rd, Doraville, GA 30340, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019dabc6-5720-740b-8346-b40f329051cb.webp",
      "poi_featured_image_media": {
        "alt_text": "Southbound train platform with seating area and signage.",
        "public_id": "019dabc6-5720-740b-8346-b40f329051cb",
        "storage_key": "property/6767906449167309/019dabc6-5720-740b-8346-b40f329051cb.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.itsmarta.com/Doraville.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=7112078237771489928&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "doraville",
      "poi_latitude": "33.9029638",
      "poi_longitude": "-84.2801456",
      "poi_miles_from_property": "22.8 mi",
      "poi_walking_minutes": "8 hours 26 mins",
      "poi_biking_minutes": "2 hours 30 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 404-848-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0e64-729d-90e0-9e323dca554b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0e64-729d-90e0-9e323dca554b",
        "storage_key": "property/6767906449167309/019d02f8-0e64-729d-90e0-9e323dca554b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ5SGscQJ9YgRiOIn0Xkts2I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "subway_station"
    },
    {
      "id": "ec_ce802f7bd1286f36a42d2a00",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Gwinnett County Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "600 Briscoe Blvd, Lawrenceville, GA 30046, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-6b02-735e-8620-1b9567311eae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02f8-6b02-735e-8620-1b9567311eae",
        "storage_key": "property/6767906449167309/019d02f8-6b02-735e-8620-1b9567311eae.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gwinnettcounty.com/portal/gwinnett/Departments/Transportation/Aviation",
      "poi_directions_map_url": "https://maps.google.com/?cid=17290050317393317144&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gwinnett-county-airport",
      "poi_latitude": "33.9754965",
      "poi_longitude": "-83.9625236",
      "poi_miles_from_property": "12.8 mi",
      "poi_walking_minutes": "4 hours 42 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 770-822-5196",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-1353-7698-bf25-1aa258cc0663.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-1353-7698-bf25-1aa258cc0663",
        "storage_key": "property/6767906449167309/019d02f8-1353-7698-bf25-1aa258cc0663.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJiVrq97m_9YgRGM3bNCiZ8u8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "ec_a6235bf35852e8d973e4b9c0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Mall of Georgia",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3333 Buford Dr, Buford, GA 30519, USA",
      "poi_short_description": "Landmark mall with grand architecture & 200+ stores on 3 levels, plus a cinema & kids’ play area.",
      "poi_long_description": "Landmark mall with grand architecture & 200+ stores on 3 levels, plus a cinema & kids’ play area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019dabba-2468-768c-bf42-49f6485709dc.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of the Mall of Georgia with Regal Cinemas signage.",
        "public_id": "019dabba-2468-768c-bf42-49f6485709dc",
        "storage_key": "property/6767906449167309/019dabba-2468-768c-bf42-49f6485709dc.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.simon.com/mall/mall-of-georgia",
      "poi_directions_map_url": "https://maps.google.com/?cid=11636229521613497056&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mall-of-georgia",
      "poi_latitude": "34.0651406",
      "poi_longitude": "-83.9844837",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 678-482-8788",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-028c-76ff-bd6a-98d5ef201468.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-028c-76ff-bd6a-98d5ef201468",
        "storage_key": "property/6767906449167309/019d02f8-028c-76ff-bd6a-98d5ef201468.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJf04EMFuU9YgR4KKvOBkxfKE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_b7f67bb2d69cb67eea14e03f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Northside Hospital Gwinnett",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1000 Medical Center Blvd, Lawrenceville, GA 30046, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f7-d1fd-726c-af5e-d14a823f3360.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02f7-d1fd-726c-af5e-d14a823f3360",
        "storage_key": "property/6767906449167309/019d02f7-d1fd-726c-af5e-d14a823f3360.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.northside.com/locations/northside-hospital-gwinnett",
      "poi_directions_map_url": "https://maps.google.com/?cid=4764224694970824387&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northside-hospital-gwinnett",
      "poi_latitude": "33.9633367",
      "poi_longitude": "-84.0175173",
      "poi_miles_from_property": "11.5 mi",
      "poi_walking_minutes": "4 hours 17 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 678-312-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0f1e-7558-abaf-7a5719529fa9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0f1e-7558-abaf-7a5719529fa9",
        "storage_key": "property/6767906449167309/019d02f8-0f1e-7558-abaf-7a5719529fa9.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJCQA6O4C-9YgRwzbhPR7tHUI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "ec_8e163531557103b931d2b2c9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Gwinnett Justice and Administration Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "75 Langley Dr, Lawrenceville, GA 30046, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019dabc6-6f77-7368-8615-af359f2d5cbe.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of the Gwinnett Justice and Administration Center with modern architecture and landscaping.",
        "public_id": "019dabc6-6f77-7368-8615-af359f2d5cbe",
        "storage_key": "property/6767906449167309/019dabc6-6f77-7368-8615-af359f2d5cbe.webp",
        "width": 3072,
        "height": 2079
      },
      "poi_business_url": "https://www.gwinnettcounty.com/home",
      "poi_directions_map_url": "https://maps.google.com/?cid=17626886500500162398&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gwinnett-justice-and-administration-center",
      "poi_latitude": "33.9506177",
      "poi_longitude": "-83.9942748",
      "poi_miles_from_property": "12.6 mi",
      "poi_walking_minutes": "4 hours 43 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 770-822-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-134f-730a-b23e-885fc69f036a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-134f-730a-b23e-885fc69f036a",
        "storage_key": "property/6767906449167309/019d02f8-134f-730a-b23e-885fc69f036a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWWr2Ku2-9YgRXsdwhuFHn_Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "ec_d3c78b3c6e60cc9bb7dcac64",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Georgia Gwinnett College",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1000 University Center Ln, Lawrenceville, GA 30043, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019dabba-316a-7197-9d0f-430fedd1fad1.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of a large brick building with a glass facade, set on a grassy field with trees and blue sky.",
        "public_id": "019dabba-316a-7197-9d0f-430fedd1fad1",
        "storage_key": "property/6767906449167309/019dabba-316a-7197-9d0f-430fedd1fad1.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.ggc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17256186828481170101&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "georgia-gwinnett-college",
      "poi_latitude": "33.9802966",
      "poi_longitude": "-84.0047709",
      "poi_miles_from_property": "11.3 mi",
      "poi_walking_minutes": "4 hours 12 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 678-407-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-09ab-742c-bdcf-1147b83d788e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-09ab-742c-bdcf-1147b83d788e",
        "storage_key": "property/6767906449167309/019d02f8-09ab-742c-bdcf-1147b83d788e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQyGfL2y-9YgRtQplSX5Keu8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_8b4ea109bc6719b5c83d6da3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "J. Alvin Wilbanks Instructional Support Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "437 Old Peachtree Rd NW #2978, Suwanee, GA 30024, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019dabba-bbe8-774e-bda4-3cce66e8da2f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dabba-bbe8-774e-bda4-3cce66e8da2f",
        "storage_key": "property/6767906449167309/019dabba-bbe8-774e-bda4-3cce66e8da2f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://publish.gwinnett.k12.ga.us/gcps/home/public/about/content/general-info/directions-to-isc",
      "poi_directions_map_url": "https://maps.google.com/?cid=7917007935513710574&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "j-alvin-wilbanks-instructional-support-center",
      "poi_latitude": "34.0155447",
      "poi_longitude": "-84.0576703",
      "poi_miles_from_property": "7.0 mi",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 678-301-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0e64-729d-90e0-9e323dca554b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0e64-729d-90e0-9e323dca554b",
        "storage_key": "property/6767906449167309/019d02f8-0e64-729d-90e0-9e323dca554b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH35v8SuW9YgR7k8-cMXc3m0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_f0cd6a7b564c50b9bc3c2931",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Primerica",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Primerica Pkwy, Duluth, GA 30099, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019f14e2-75a2-705e-b6dc-d4cc7b8666fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e2-75a2-705e-b6dc-d4cc7b8666fa",
        "storage_key": "property/6767906449167309/019f14e2-75a2-705e-b6dc-d4cc7b8666fa.webp",
        "width": 1280,
        "height": 1041
      },
      "poi_business_url": "https://www.primerica.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5503230353377965328&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "primerica",
      "poi_latitude": "33.9858655",
      "poi_longitude": "-84.09773609999999",
      "poi_miles_from_property": "10.9 mi",
      "poi_walking_minutes": "4 hours 1 min",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 770-381-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0e64-729d-90e0-9e323dca554b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0e64-729d-90e0-9e323dca554b",
        "storage_key": "property/6767906449167309/019d02f8-0e64-729d-90e0-9e323dca554b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4cIYRDS99YgRELU9WtlmX0w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_e7ac11d6a4e54ccf5f821739",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Northside Hospital Duluth",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3620 Howell Ferry Rd NW, Duluth, GA 30096, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019dabc5-f630-73ff-a137-4f928ad99f07.webp",
      "poi_featured_image_media": {
        "alt_text": "Northside Hospital Duluth exterior with signage and flags.",
        "public_id": "019dabc5-f630-73ff-a137-4f928ad99f07",
        "storage_key": "property/6767906449167309/019dabc5-f630-73ff-a137-4f928ad99f07.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.northside.com/locations/northside-hospital-duluth",
      "poi_directions_map_url": "https://maps.google.com/?cid=12519573937524282368&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northside-hospital-duluth",
      "poi_latitude": "33.9991071",
      "poi_longitude": "-84.1630921",
      "poi_miles_from_property": "13.5 mi",
      "poi_walking_minutes": "4 hours 59 mins",
      "poi_biking_minutes": "1 hour 34 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 678-312-6800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0f1e-7558-abaf-7a5719529fa9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0f1e-7558-abaf-7a5719529fa9",
        "storage_key": "property/6767906449167309/019d02f8-0f1e-7558-abaf-7a5719529fa9.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJFcRpt2yi9YgRAJRfJSp2vq0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_ca5a7131a362d74b15352e78",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Piedmont Eastside Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1700 Medical Way, Snellville, GA 30078, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019f14e2-76d2-703e-af66-1ad8b6cb1d51.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e2-76d2-703e-af66-1ad8b6cb1d51",
        "storage_key": "property/6767906449167309/019f14e2-76d2-703e-af66-1ad8b6cb1d51.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.piedmont.org/locations/piedmont-eastside-medical-center?utm_source=directorylisting&utm_medium=seo&utm_campaign=10223&y_source=1_MjY4OTU4ODctNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=8293276328954316881&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "piedmont-eastside-medical-center",
      "poi_latitude": "33.8769038",
      "poi_longitude": "-84.0210179",
      "poi_miles_from_property": "18.4 mi",
      "poi_walking_minutes": "6 hours 54 mins",
      "poi_biking_minutes": "1 hour 37 mins",
      "poi_driving_minutes": "33 mins",
      "poi_business_phone": "+1 770-979-0200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0f1e-7558-abaf-7a5719529fa9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0f1e-7558-abaf-7a5719529fa9",
        "storage_key": "property/6767906449167309/019d02f8-0f1e-7558-abaf-7a5719529fa9.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJP_cKkNS79YgRUUh6q-GiF3M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_f3afd82cc8b9b6f15baa9404",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "Price Industries Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2975 Shawnee Ridge Ct NW #3638, Suwanee, GA 30024, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019f14e2-9806-71de-bfcf-6af0754b7e6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e2-9806-71de-bfcf-6af0754b7e6d",
        "storage_key": "property/6767906449167309/019f14e2-9806-71de-bfcf-6af0754b7e6d.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "http://www.priceindustries.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7479044992700517462&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "price-industries-inc",
      "poi_latitude": "34.0177573",
      "poi_longitude": "-84.0720039",
      "poi_miles_from_property": "7.8 mi",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 770-623-8050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0e64-729d-90e0-9e323dca554b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0e64-729d-90e0-9e323dca554b",
        "storage_key": "property/6767906449167309/019d02f8-0e64-729d-90e0-9e323dca554b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW8u1S9qX9YgRVgwUkcvnymc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "ec_67d97c40d918a2d12df3c7cb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "generator",
      "poi_name": "WIKA Instrument, LP",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1000 Wiegand Blvd, Lawrenceville, GA 30043, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019f14e2-7868-7347-a50f-38e44b7910b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e2-7868-7347-a50f-38e44b7910b1",
        "storage_key": "property/6767906449167309/019f14e2-7868-7347-a50f-38e44b7910b1.webp",
        "width": 1075,
        "height": 544
      },
      "poi_business_url": "https://www.wika.com/en-us/startpage.WIKA",
      "poi_directions_map_url": "https://maps.google.com/?cid=15837019284971171583&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wika-instrument-lp",
      "poi_latitude": "33.9609457",
      "poi_longitude": "-84.05272029999999",
      "poi_miles_from_property": "11.6 mi",
      "poi_walking_minutes": "4 hours 16 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 888-945-2872",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f8-0e64-729d-90e0-9e323dca554b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-0e64-729d-90e0-9e323dca554b",
        "storage_key": "property/6767906449167309/019d02f8-0e64-729d-90e0-9e323dca554b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTf0wlFO89YgR_663rSFlyNs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    }
  ],
  "office_hours": [
    {
      "id": "custom_029cbfcf-1ed3-4ac6-b2a2-aa7010946589",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_2fe9d139-5538-47c2-b681-d010967386de",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_d8afb3f2-2c7e-4bc9-a368-84ee78360939",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_d8da79b8-ac68-4a14-9b3a-d80d360f5706",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_c270e33f-0eab-4480-8365-e62f46ad6aef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_0bc04065-0e5d-4f3a-85d7-2f11740a0554",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_4790740f-0267-4649-ad35-d7c7c4cd8805",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "day": "SUN",
      "open_time": "13:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_d535af2be31649534f030b53",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "rating": "5",
      "name": "Jan pearce",
      "text": "We have lived here 3 years and have renewed for year 4. The complex is quiet, and close to shopping. I love it because I feel safe and if I need any repairs or help the staff here is always eager to help. I have found my neighbors and those in the complex to be kind  and the conversations I had with many of them are like me… happy to be here. This place feels like home for me.",
      "date": "2026-02-19",
      "title": "false"
    },
    {
      "id": "ec_c6a5cd253f0b96ca03b9024c",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "rating": "5",
      "name": "Melissa Gasparetto",
      "text": "I am living here for almost 7 months and I love it. Miah is an amazing person from the office that always helps me with anything that I need. The neighbors are great and we did not had any problems so far. Ten stars for maintenance 🙌 they are super professional and super fast to come check anything that I asked for. I highly recommend  Preserve at Mill Creek to anyone that wants to live in a secure, quiet and calm environment.",
      "date": "2023-12-17",
      "title": "false"
    },
    {
      "id": "ec_ad24066dcab3a4fd3daf1fe7",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "rating": "5",
      "name": "Jennifer Link",
      "text": "Beautiful community and apartments. Great experience during our tour and overall. The lovely walking trails and beautiful Creek that runs through the back near the walking path was definitely a plus. Preserve at Mill Creek became the top of our list when applying for apartments. The staff was extremely lovely and helpful in answering all of our questions.",
      "date": "2026-03-24",
      "title": "false"
    },
    {
      "id": "ec_6f911a531618f10514989294",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "rating": "5",
      "name": "MomLife LifeWithBoys",
      "text": "Wonderful staff! Very beautiful property. It has an overlook area with a beautiful view of the creek and entrance to Ivy creek trail. So peaceful. Management and support staff always handles my concerns in a timely manner.  Love my new apartment! Happy resident!",
      "date": "2026-01-23",
      "title": "false"
    },
    {
      "id": "ec_ff54af529ed8413681e432fc",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "rating": "5",
      "name": "C Ingram",
      "text": "I love living here. The front office staff, especially Wendy, has made things so easy for us. If we have any questions or issues she is always available to help in anyway. The complex is quiet and next to a river. It’s pretty peaceful to be next to such a busy area. Maintenance is always friendly and quick to fix things. Definitely very happy tenants!",
      "date": "2026-01-13",
      "title": "false"
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019dabd5-2fcd-703a-8234-bf1b3ca17a25",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "american-landmark-preserve-at-mill-creek",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309"
    },
    {
      "lead_collector_id": "019db09f-f6c5-711c-95c8-192a2ce4f5ea",
      "lead_source": "LANDING_PAGE",
      "name": "american-landmark-preserve-at-mill-creek-lp",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "page_item_url": "in-unit-laundry-apartments-buford-ga-607",
      "search_query": "in unit laundry apartments Buford GA",
      "category": "Amenity",
      "h1_title": "In Unit Laundry Apartments in Buford, GA",
      "h2_subtitle": "Looking for in unit laundry apartments in Buford, GA? Discover the convenience and comfort offered by the Preserve at Mill Creek.",
      "page_copy": "Explore convenient living at the Preserve at Mill Creek, where in-unit laundry apartments in Buford, GA redefine ease and modern living. Our stunning one, two, and three-bedroom floor plans feature modern touches like stainless steel appliances, ensuring every aspect of your home meets your lifestyle needs. \n\nSay goodbye to the hassle of shared laundry spaces. Enjoy the privacy and convenience of in-unit laundry, complemented by a range of on-site amenities such as a resort-style pool, planned social activities, and private patios or balconies. At the Preserve at Mill Creek, we focus on making life both luxurious and comfortable.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f7-4a9a-751a-80a2-c16703298662.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool and lounge chairs with a tennis court and playground in the background.",
        "public_id": "019d02f7-4a9a-751a-80a2-c16703298662",
        "storage_key": "property/6767906449167309/019d02f7-4a9a-751a-80a2-c16703298662.webp",
        "width": 1280,
        "height": 720
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In Unit Laundry Apartments Buford, GA",
      "seo_description": "Discover in unit laundry apartments in Buford, GA at the Preserve at Mill Creek, where convenience meets modern living. Learn more today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "page_item_url": "luxury-apartments-with-pool-duluth-417",
      "search_query": "luxury apartments with pool Duluth",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in Duluth",
      "h2_subtitle": "Discover luxury apartments with pool access in the Duluth area. Experience unmatched comfort at the Preserve at Mill Creek.",
      "page_copy": "Welcome to a life of luxury at the Preserve at Mill Creek, offering exquisite apartments near Duluth with a sparkling resort-style pool. Our spacious one, two, and three-bedroom homes provide modern amenities, ensuring a refined living experience. \n\nNestled in the vibrant Duluth area, these luxury apartments come with exclusive access to our scenic courtyard and planned social activities. Enjoy a refreshing dip in the pool or relax on your private patio or balcony—life here is both exciting and serene. Join a community where luxury meets tranquility right near Duluth!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f7-4a9a-751a-80a2-c16703298662.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool and lounge chairs with a tennis court and playground in the background.",
        "public_id": "019d02f7-4a9a-751a-80a2-c16703298662",
        "storage_key": "property/6767906449167309/019d02f7-4a9a-751a-80a2-c16703298662.webp",
        "width": 1280,
        "height": 720
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool Duluth Area",
      "seo_description": "Explore luxury apartments with a pool near Duluth at the Preserve at Mill Creek. Enjoy modern amenities and a resort-style lifestyle!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "page_item_url": "apartment-with-air-conditioning-gwinnett-county-821",
      "search_query": "apartment with air conditioning Gwinnett County",
      "category": "Amenity",
      "h1_title": "Apartment with Air Conditioning in Gwinnett",
      "h2_subtitle": "Find the perfect apartment with air conditioning in Gwinnett County. Enjoy comfort and luxury at the Preserve at Mill Creek.",
      "page_copy": "Stay cool in style at the Preserve at Mill Creek, where each apartment in Gwinnett County features air conditioning for your comfort. Our modern one, two, and three-bedroom homes offer spacious layouts and upscale amenities designed to enhance your living experience.\n\nLocated in the heart of Gwinnett County, our community provides not just air-conditioned comfort but also luxurious facilities such as a resort-style pool and scenic courtyard. Enjoy everything from stainless steel appliances to planned social activities, all within a vibrant and welcoming neighborhood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f7-4a9a-751a-80a2-c16703298662.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool and lounge chairs with a tennis court and playground in the background.",
        "public_id": "019d02f7-4a9a-751a-80a2-c16703298662",
        "storage_key": "property/6767906449167309/019d02f7-4a9a-751a-80a2-c16703298662.webp",
        "width": 1280,
        "height": 720
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment with Air Conditioning Gwinnett County",
      "seo_description": "Discover apartments with air conditioning in Gwinnett County at the Preserve at Mill Creek. Experience comfort and luxury in every home.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "page_item_url": "dishwasher-equipped-apartments-near-mall-of-georgia-417",
      "search_query": "dishwasher equipped apartments near Mall of Georgia",
      "category": "Amenity",
      "h1_title": "Dishwasher Apartments Near Mall of Georgia",
      "h2_subtitle": "Discover dishwasher-equipped apartments near the Mall of Georgia. Enjoy modern living at the Preserve at Mill Creek.",
      "page_copy": "Experience the convenience of dishwasher-equipped apartments near the Mall of Georgia at the Preserve at Mill Creek. Our modern one, two, and three-bedroom homes offer well-appointed kitchens with stainless steel appliances, making cleanup a breeze.\n\nAlong with the convenience of a built-in dishwasher, residents enjoy an array of amenities such as a resort-style pool, private balconies, and planned social activities. Located just moments away from the Mall of Georgia, our community offers both convenience and luxury, making it the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f7-4a9a-751a-80a2-c16703298662.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool and lounge chairs with a tennis court and playground in the background.",
        "public_id": "019d02f7-4a9a-751a-80a2-c16703298662",
        "storage_key": "property/6767906449167309/019d02f7-4a9a-751a-80a2-c16703298662.webp",
        "width": 1280,
        "height": 720
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dishwasher Apartments Near Mall of Georgia",
      "seo_description": "Explore dishwasher-equipped apartments near the Mall of Georgia at the Preserve at Mill Creek. Enjoy convenient, modern living today.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-in-buford-ga-721",
      "search_query": "one bedroom apartments in Buford GA",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Buford, GA",
      "h2_subtitle": "Explore spacious one bedroom apartments in Buford, GA. Enjoy modern amenities at the Preserve at Mill Creek.",
      "page_copy": "Discover the perfect one bedroom apartment in Buford, GA at the Preserve at Mill Creek. Our thoughtfully designed homes feature modern amenities like stainless steel appliances, expansive closets, and a private patio or balcony, enhancing your living experience.\n\nNestled in vibrant Buford, our community not only offers stylish one bedroom apartments but also fantastic neighborhood access. With a resort-style pool and planned social activities, it's easy to see why our residents love calling Preserve at Mill Creek home. Experience comfort and convenience in every aspect of living here.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f7-4a9a-751a-80a2-c16703298662.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool and lounge chairs with a tennis court and playground in the background.",
        "public_id": "019d02f7-4a9a-751a-80a2-c16703298662",
        "storage_key": "property/6767906449167309/019d02f7-4a9a-751a-80a2-c16703298662.webp",
        "width": 1280,
        "height": 720
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Buford, GA",
      "seo_description": "Find modern one bedroom apartments in Buford, GA at the Preserve at Mill Creek. Enjoy spacious living and top-tier amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-gwinnett-county-217",
      "search_query": "two bedroom apartments Gwinnett County",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Gwinnett County",
      "h2_subtitle": "Discover spacious two bedroom apartments in Gwinnett County. Enjoy luxurious living at the Preserve at Mill Creek.",
      "page_copy": "Experience spacious two bedroom apartments in Gwinnett County at the Preserve at Mill Creek. Our modern apartment homes are designed for both comfort and style, featuring stainless steel appliances and large closets that provide ample storage.\n\nLocated in the heart of Buford, our community offers more than just spacious apartments. With amenities like a resort-style pool, scenic courtyard, and a variety of planned social activities, the Preserve at Mill Creek is the ideal place to live, work, and play. Enjoy the convenience of being in Gwinnett County with access to great neighborhood amenities and activities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f7-4a9a-751a-80a2-c16703298662.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool and lounge chairs with a tennis court and playground in the background.",
        "public_id": "019d02f7-4a9a-751a-80a2-c16703298662",
        "storage_key": "property/6767906449167309/019d02f7-4a9a-751a-80a2-c16703298662.webp",
        "width": 1280,
        "height": 720
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Gwinnett County",
      "seo_description": "Explore two bedroom apartments in Gwinnett County at the Preserve at Mill Creek. Enjoy luxury and comfort with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-near-duluth-ga-354",
      "search_query": "three bedroom apartments near Duluth GA",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near Duluth, GA",
      "h2_subtitle": "Explore luxurious three bedroom apartments near Duluth, GA. Discover spacious living at the Preserve at Mill Creek.",
      "page_copy": "Looking for spacious three bedroom apartments near Duluth, GA? The Preserve at Mill Creek offers beautiful homes that combine luxury with practical living. Each three bedroom unit features modern amenities such as stainless steel appliances, expansive closets, and a private balcony for an elevated living experience.\n\nPositioned conveniently close to Duluth within Gwinnett County, our community provides more than just apartment living. Indulge in the resort-style pool, partake in various planned social activities, or unwind in our beautifully maintained courtyard. Choose the Preserve at Mill Creek for an unmatched lifestyle close to Duluth, GA.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f7-4a9a-751a-80a2-c16703298662.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool and lounge chairs with a tennis court and playground in the background.",
        "public_id": "019d02f7-4a9a-751a-80a2-c16703298662",
        "storage_key": "property/6767906449167309/019d02f7-4a9a-751a-80a2-c16703298662.webp",
        "width": 1280,
        "height": 720
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near Duluth, GA",
      "seo_description": "Find three bedroom apartments near Duluth, GA at the Preserve at Mill Creek. Enjoy spacious living with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "page_item_url": "apartments-near-buford-elementary-school-ga-38",
      "search_query": "apartments near Buford Elementary School GA",
      "category": "School",
      "h1_title": "Apartments Near Buford Elementary School GA",
      "h2_subtitle": "Discover convenient apartments near Buford Elementary School, GA. Preserve at Mill Creek offers a perfect blend of comfort and accessibility.",
      "page_copy": "Families seeking apartments near Buford Elementary School, GA, will find the Preserve at Mill Creek an ideal choice. Our community offers spacious one, two, and three-bedroom floor plans designed with modern amenities like stainless steel appliances and private balconies, ensuring a comfortable family living experience.\n\nConveniently located in Buford, our community is not only close to Buford Elementary School but also packed with family-friendly amenities. Enjoy the resort-style pool, partake in planned social activities, and make use of the expansive courtyard. Experience the added convenience of living in Gwinnett County with premier accessibility to educational institutions.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f7-4a9a-751a-80a2-c16703298662.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool and lounge chairs with a tennis court and playground in the background.",
        "public_id": "019d02f7-4a9a-751a-80a2-c16703298662",
        "storage_key": "property/6767906449167309/019d02f7-4a9a-751a-80a2-c16703298662.webp",
        "width": 1280,
        "height": 720
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Buford Elementary School GA",
      "seo_description": "Find apartments near Buford Elementary School, GA at the Preserve at Mill Creek. Ideal for families seeking comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "page_item_url": "apartments-near-buford-high-school-gwinnett-county-606",
      "search_query": "apartments near Buford High School Gwinnett County",
      "category": "School",
      "h1_title": "Apartments Near Buford High School, GA",
      "h2_subtitle": "Explore convenient apartments near Buford High School in Gwinnett County. Experience exceptional living at the Preserve at Mill Creek.",
      "page_copy": "Looking for apartments near Buford High School in Gwinnett County? The Preserve at Mill Creek offers a perfect mix of comfort and convenience, ideal for families. Our community features spacious one, two, and three-bedroom floor plans with contemporary amenities such as stainless steel appliances, private patios or balconies, and expansive closets.\n\nLocated in Buford, the Preserve at Mill Creek provides easy access to Buford High School and other key local attractions. Residents enjoy a resort-style pool, planned social activities, and beautifully landscaped courtyards, making it an exceptional choice for family living in Gwinnett County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f7-4a9a-751a-80a2-c16703298662.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool and lounge chairs with a tennis court and playground in the background.",
        "public_id": "019d02f7-4a9a-751a-80a2-c16703298662",
        "storage_key": "property/6767906449167309/019d02f7-4a9a-751a-80a2-c16703298662.webp",
        "width": 1280,
        "height": 720
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Buford High School, GA",
      "seo_description": "Find ideal apartments near Buford High School in Gwinnett County at the Preserve at Mill Creek. Perfect for family-friendly living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "page_item_url": "apartments-close-to-buford-academy-buford-ga-753",
      "search_query": "apartments close to Buford Academy Buford GA",
      "category": "School",
      "h1_title": "Apartments Close to Buford Academy, GA",
      "h2_subtitle": "Discover perfect apartments close to Buford Academy in Buford, GA. Enjoy modern living at Preserve at Mill Creek.",
      "page_copy": "Families searching for apartments close to Buford Academy in Buford, GA, will appreciate the amenities and prime location offered by the Preserve at Mill Creek. Our community boasts spacious one, two, and three-bedroom floor plans, each featuring premium amenities such as stainless steel appliances, crown molding, and private patios or balconies.\n\nNestled in Buford, our community provides convenient access to Buford Academy, making school commutes a breeze. Residents can enjoy a resort-style pool, engage in planned social activities, and savor moments in our serene courtyards, perfect for family relaxation. Experience the ideal blend of location and lifestyle at the Preserve at Mill Creek.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f7-4a9a-751a-80a2-c16703298662.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool and lounge chairs with a tennis court and playground in the background.",
        "public_id": "019d02f7-4a9a-751a-80a2-c16703298662",
        "storage_key": "property/6767906449167309/019d02f7-4a9a-751a-80a2-c16703298662.webp",
        "width": 1280,
        "height": 720
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Buford Academy, GA",
      "seo_description": "Find ideal apartments close to Buford Academy in Buford, GA at Preserve at Mill Creek. Perfect for modern, family-friendly living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "page_item_url": "apartments-near-buford-senior-academy-ga-362",
      "search_query": "apartments near Buford Senior Academy GA",
      "category": "School",
      "h1_title": "Apartments Near Buford Senior Academy, GA",
      "h2_subtitle": "Explore excellent apartments near Buford Senior Academy in GA. Enjoy luxury living at the Preserve at Mill Creek.",
      "page_copy": "If you're looking for apartments near Buford Senior Academy in GA, the Preserve at Mill Creek offers the perfect location and lifestyle. Our community provides spacious one, two, and three-bedroom options, complete with modern amenities like stainless steel appliances and private balconies.\n\nConveniently situated in Buford, our apartments ensure easy commutes to Buford Senior Academy. Enjoy our resort-style pool, participate in social activities, and relax amid our beautiful, green courtyards. The Preserve at Mill Creek blends convenience with luxury, making it an ideal choice for families and professionals alike.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f7-4a9a-751a-80a2-c16703298662.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool and lounge chairs with a tennis court and playground in the background.",
        "public_id": "019d02f7-4a9a-751a-80a2-c16703298662",
        "storage_key": "property/6767906449167309/019d02f7-4a9a-751a-80a2-c16703298662.webp",
        "width": 1280,
        "height": 720
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Buford Senior Academy, GA",
      "seo_description": "Discover luxury apartments near Buford Senior Academy in GA at the Preserve at Mill Creek. Perfect for modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "page_item_url": "apartments-near-patrick-elementary-school-buford-ga-859",
      "search_query": "apartments near Patrick Elementary School Buford GA",
      "category": "School",
      "h1_title": "Apartments Near Patrick Elementary School, GA",
      "h2_subtitle": "Find ideal apartments near Patrick Elementary School in Buford, GA. Experience comfort at Preserve at Mill Creek.",
      "page_copy": "Searching for apartments near Patrick Elementary School in Buford, GA? Look no further than the Preserve at Mill Creek, where you'll find a blend of luxury and convenience. Our community offers one, two, and three-bedroom floor plans complemented by amenities like stainless steel appliances, private balconies, and crown molding.\n\nSituated in Buford, the Preserve at Mill Creek ensures quick access to Patrick Elementary School, ideal for families seeking easy school commutes. Enjoy an array of community features, such as a resort-style pool and planned social activities, tailored to enhance your living experience. Discover a vibrant community lifestyle at the Preserve at Mill Creek.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f7-4a9a-751a-80a2-c16703298662.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool and lounge chairs with a tennis court and playground in the background.",
        "public_id": "019d02f7-4a9a-751a-80a2-c16703298662",
        "storage_key": "property/6767906449167309/019d02f7-4a9a-751a-80a2-c16703298662.webp",
        "width": 1280,
        "height": 720
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Patrick Elementary School, GA",
      "seo_description": "Find luxury apartments near Patrick Elementary School in Buford, GA at Preserve at Mill Creek. Perfect for a convenient lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "page_item_url": "apartments-near-georgia-gwinnett-college-buford-388",
      "search_query": "apartments near Georgia Gwinnett College Buford",
      "category": "School",
      "h1_title": "Apartments Near Georgia Gwinnett College",
      "h2_subtitle": "Live near Georgia Gwinnett College in Buford. Discover luxury living at the Preserve at Mill Creek.",
      "page_copy": "For students and faculty seeking apartments near Georgia Gwinnett College in Buford, the Preserve at Mill Creek offers a perfect solution. Our community features luxurious one, two, and three-bedroom floor plans, complete with stainless steel appliances and spacious closets.\n\nPositioned conveniently for easy commutes to Georgia Gwinnett College, the Preserve at Mill Creek combines modern amenities with serene living. Enjoy our resort-style pool and vibrant community activities, ensuring a balanced lifestyle for both study and relaxation. Embrace comfortable and convenient living at this desirable Buford location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f7-4a9a-751a-80a2-c16703298662.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool and lounge chairs with a tennis court and playground in the background.",
        "public_id": "019d02f7-4a9a-751a-80a2-c16703298662",
        "storage_key": "property/6767906449167309/019d02f7-4a9a-751a-80a2-c16703298662.webp",
        "width": 1280,
        "height": 720
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Georgia Gwinnett College, Buford",
      "seo_description": "Discover luxury apartments near Georgia Gwinnett College in Buford at the Preserve at Mill Creek. Ideal for students and faculty.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "page_item_url": "apartments-near-ivy-creek-greenway-buford-777",
      "search_query": "apartments near Ivy Creek Greenway in Buford",
      "category": "Park",
      "h1_title": "Apartments Near Ivy Creek Greenway, Buford",
      "h2_subtitle": "Explore vibrant living with apartments near Ivy Creek Greenway in Buford. Discover Preserve at Mill Creek.",
      "page_copy": "If you're searching for apartments near Ivy Creek Greenway in Buford, the Preserve at Mill Creek is the perfect blend of luxury and nature. Our community offers one, two, and three-bedroom floor plans replete with contemporary amenities like stainless steel appliances, expansive closets, and private outdoor spaces.\n\nEnjoy the natural beauty of Ivy Creek Greenway just minutes from your doorstep, while indulging in the luxurious features of the Preserve at Mill Creek such as a resort-style pool and a dynamic calendar of planned social activities. Experience the best of both outdoor adventure and modern living in Buford.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f7-4a9a-751a-80a2-c16703298662.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool and lounge chairs with a tennis court and playground in the background.",
        "public_id": "019d02f7-4a9a-751a-80a2-c16703298662",
        "storage_key": "property/6767906449167309/019d02f7-4a9a-751a-80a2-c16703298662.webp",
        "width": 1280,
        "height": 720
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Ivy Creek Greenway, Buford",
      "seo_description": "Find ideal apartments near Ivy Creek Greenway in Buford at Preserve at Mill Creek. Embrace nature and luxury living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "page_item_url": "apartments-near-town-center-park-gwinnett-county-408",
      "search_query": "apartments near Town Center Park Gwinnett County",
      "category": "Park",
      "h1_title": "Apartments Near Town Center Park",
      "h2_subtitle": "Discover your new home near Town Center Park in Gwinnett County. Explore Preserve at Mill Creek's luxury apartments.",
      "page_copy": "For those looking for apartments near Town Center Park in Gwinnett County, the Preserve at Mill Creek offers a perfect mix of convenience and luxury. Situated in Buford, our community provides a selection of spacious one, two, and three-bedroom apartments equipped with modern amenities like stainless steel appliances and expansive closets.\n\nEnjoy proximity to Town Center Park along with features such as a resort-style pool and vibrant social gatherings. At the Preserve at Mill Creek, residents relish a lifestyle that's both comfortable and engaging, surrounded by the beauty of Gwinnett County. Experience exceptional living just minutes away from all the action.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f7-4a9a-751a-80a2-c16703298662.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool and lounge chairs with a tennis court and playground in the background.",
        "public_id": "019d02f7-4a9a-751a-80a2-c16703298662",
        "storage_key": "property/6767906449167309/019d02f7-4a9a-751a-80a2-c16703298662.webp",
        "width": 1280,
        "height": 720
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Town Center Park, Gwinnett County",
      "seo_description": "Find luxury apartments near Town Center Park in Gwinnett County at the Preserve at Mill Creek. Enjoy a blend of comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "page_item_url": "suwanee-creek-park-adjacent-apartments-140",
      "search_query": "Suwanee Creek Park adjacent apartments",
      "category": "Park",
      "h1_title": "Adjacent Apartments to Suwanee Creek Park",
      "h2_subtitle": "Live close to nature with Suwanee Creek Park adjacent apartments. Discover Preserve at Mill Creek.",
      "page_copy": "Experience the harmony of nature and luxury living with apartments adjacent to Suwanee Creek Park. The Preserve at Mill Creek offers elegantly designed one, two, and three-bedroom homes enriched with features like stainless steel appliances, private balconies, and spacious closets.\n\nLocated just a short commute from Suwanee Creek Park, our residents enjoy conveniences such as a resort-style pool and engaging social activities, all within a vibrant community setting. Embrace an outdoor lifestyle with quick access to the beauty of Suwanee Creek Park while enjoying the modern comforts at Preserve at Mill Creek.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f7-4a9a-751a-80a2-c16703298662.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool and lounge chairs with a tennis court and playground in the background.",
        "public_id": "019d02f7-4a9a-751a-80a2-c16703298662",
        "storage_key": "property/6767906449167309/019d02f7-4a9a-751a-80a2-c16703298662.webp",
        "width": 1280,
        "height": 720
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Suwanee Creek Park Adjacent Apartments",
      "seo_description": "Explore Preserve at Mill Creek's adjacent apartments near Suwanee Creek Park. Combine luxury living with natural beauty.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "page_item_url": "buford-city-park-accessible-apartments-129",
      "search_query": "Buford City Park accessible apartments",
      "category": "Park",
      "h1_title": "Accessible Apartments Near Buford City Park",
      "h2_subtitle": "Discover convenient living with accessible apartments near Buford City Park. Explore life at Preserve at Mill Creek.",
      "page_copy": "For those seeking accessible apartments near Buford City Park, the Preserve at Mill Creek is an ideal choice. Nestled in the heart of Buford, this community offers one, two, and three-bedroom floor plans, each equipped with modern comforts such as stainless steel appliances and private balconies.\n\nResidents enjoy easy access to the recreational offerings of Buford City Park, while also taking advantage of amenities like a resort-style pool and planned social activities at home. Immerse yourself in a lifestyle that combines convenience, accessibility, and modern living at Preserve at Mill Creek, just moments away from Buford City Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f7-4a9a-751a-80a2-c16703298662.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool and lounge chairs with a tennis court and playground in the background.",
        "public_id": "019d02f7-4a9a-751a-80a2-c16703298662",
        "storage_key": "property/6767906449167309/019d02f7-4a9a-751a-80a2-c16703298662.webp",
        "width": 1280,
        "height": 720
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Buford City Park Accessible Apartments",
      "seo_description": "Find accessible apartments near Buford City Park at Preserve at Mill Creek. Enjoy modern living and park-side convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "page_item_url": "sims-lake-park-suwanee-close-apartments-972",
      "search_query": "Sims Lake Park Suwanee close apartments",
      "category": "Park",
      "h1_title": "Close Apartments to Sims Lake Park, Suwanee",
      "h2_subtitle": "Enjoy living in close proximity to Sims Lake Park in Suwanee. Discover apartments at Preserve at Mill Creek.",
      "page_copy": "Find your next home at the Preserve at Mill Creek, offering apartments conveniently close to Sims Lake Park in Suwanee. Choose from our spacious one, two, or three-bedroom floor plans that come with modern amenities such as stainless steel appliances, private balconies, and ample closets.\n\nLiving near Sims Lake Park provides endless opportunities for outdoor adventures, all while enjoying the comfort and convenience of community perks like a resort-style pool and planned social activities. Experience a blend of nature and luxury at the Preserve at Mill Creek, perfectly situated near the scenic beauty of Sims Lake Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f7-4a9a-751a-80a2-c16703298662.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool and lounge chairs with a tennis court and playground in the background.",
        "public_id": "019d02f7-4a9a-751a-80a2-c16703298662",
        "storage_key": "property/6767906449167309/019d02f7-4a9a-751a-80a2-c16703298662.webp",
        "width": 1280,
        "height": 720
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Close Apartments to Sims Lake Park, Suwanee",
      "seo_description": "Explore Preserve at Mill Creek's apartments close to Sims Lake Park in Suwanee. Enjoy luxury living near natural beauty.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "page_item_url": "apartments-near-doraville-transit-buford-ga-963",
      "search_query": "apartments near Doraville transit Buford GA",
      "category": "Transit",
      "h1_title": "Apartments Near Doraville Transit in Buford",
      "h2_subtitle": "Explore convenient living with apartments near Doraville transit in Buford, GA. Welcome to Preserve at Mill Creek.",
      "page_copy": "If you're seeking apartments with easy access to Doraville transit, Preserve at Mill Creek in Buford, GA, might just be your ideal home. Our community offers beautifully designed one, two, and three-bedroom floor plans, complete with modern amenities such as stainless steel appliances, spacious closets, and private balconies, ensuring a comfortable lifestyle.\n\nSituated conveniently near Doraville transit, commuting to and from work or leisure activities becomes effortless. Residents also benefit from on-site features like a resort-style pool and planned social events, creating an enriched living experience. Choose Preserve at Mill Creek for a seamless blend of comfort, accessibility, and community closeness.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f7-4a9a-751a-80a2-c16703298662.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool and lounge chairs with a tennis court and playground in the background.",
        "public_id": "019d02f7-4a9a-751a-80a2-c16703298662",
        "storage_key": "property/6767906449167309/019d02f7-4a9a-751a-80a2-c16703298662.webp",
        "width": 1280,
        "height": 720
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Doraville Transit in Buford",
      "seo_description": "Discover Preserve at Mill Creek's apartments with accessibility to Doraville transit in Buford, GA. Enjoy modern living and easy commuting.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167309",
      "source": "custom",
      "page_item_url": "apartments-convenient-to-hartsfield-jackson-airport-gwinnett-65",
      "search_query": "apartments convenient to Hartsfield-Jackson Atlanta International Airport Gwinnett County",
      "category": "Transit",
      "h1_title": "Convenient Apartments to Hartsfield-Jackson Airport",
      "h2_subtitle": "Discover apartments convenient to Hartsfield-Jackson Atlanta International Airport in Gwinnett County. Welcome to Preserve at Mill Creek.",
      "page_copy": "Living at the Preserve at Mill Creek offers you easy accessibility to Hartsfield-Jackson Atlanta International Airport, while nestled in the tranquility of Gwinnett County. Our one, two, and three-bedroom apartments are designed with modern conveniences like stainless steel appliances, extensive closet spaces, and private balconies.\n\nSituated for quick access to major travel routes, Preserve at Mill Creek makes commuting to the airport smooth and stress-free. Enjoy on-site amenities including a resort-style pool and active social events, all while living in a peaceful community environment. Find the perfect balance between a convenient location and quality living here in Buford.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019d02f7-4a9a-751a-80a2-c16703298662.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool and lounge chairs with a tennis court and playground in the background.",
        "public_id": "019d02f7-4a9a-751a-80a2-c16703298662",
        "storage_key": "property/6767906449167309/019d02f7-4a9a-751a-80a2-c16703298662.webp",
        "width": 1280,
        "height": 720
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Convenient Apartments to Hartsfield-Jackson Airport",
      "seo_description": "Discover Preserve at Mill Creek's Gwinnett County apartments with easy access to Hartsfield-Jackson Airport. Enjoy luxury with convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "6043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11527115999"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5652607"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PJJB6HTS"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "4"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "52980754854"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "f1c53250aad24211"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "678-345-0618"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IldtbWtBVnJLVjhKQ0U5NUk2UUpaeEE9PSIsInZhbHVlIjoiS0NQVWtWTVhsTGNaK2dOYWJwUU9CQT09IiwibWFjIjoiZTZmMDE1MTg2NTc5MzIwYjBkNjg0OGZhODZiM2QwMTM5YWIwYjg4ZjBkZGNmZjExZjIyNjJhZTJmYjllY2UwMyJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "6043",
  "custom_repli_id": "11527115999",
  "custom_realpage_id": "5652607",
  "custom_google_gtm_id": "GTM-PJJB6HTS",
  "custom_rollout_phase": "4",
  "custom_ads_subscription": "none",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "full_stack",
  "custom_hubspot_company_id": "52980754854",
  "custom_knock_community_id": "f1c53250aad24211",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "678-345-0618",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IldtbWtBVnJLVjhKQ0U5NUk2UUpaeEE9PSIsInZhbHVlIjoiS0NQVWtWTVhsTGNaK2dOYWJwUU9CQT09IiwibWFjIjoiZTZmMDE1MTg2NTc5MzIwYjBkNjg0OGZhODZiM2QwMTM5YWIwYjg4ZjBkZGNmZjExZjIyNjJhZTJmYjllY2UwMyJ9",
  "custom_household_income_qualification_multiplier": "3",
  "custom_audioeye_site_id": "4783e32b-a818-4248-857a-6b6aac5f8012",
  "custom_audioeye_site_hash": "996fbe79d4ddfeb0efca41ae81b13cda"
};

export const generatedAt = '2026-11-03T20:23:47.610Z';
